import React, { createContext, useContext, useState, useCallback } from "react";

const dictionaries = {
  fr: {
    "auth.welcome": "Bon retour",
    "auth.loginSubtitle": "Connectez-vous à votre espace de travail",
    "auth.phone": "Numéro de téléphone",
    "auth.password": "Mot de passe",
    "auth.login": "Se connecter",
    "auth.google": "Continuer avec Google",
    "auth.googleSoon": "Bientôt disponible",
    "auth.noAccount": "Pas de compte ?",
    "auth.register": "Créer un compte",
    "auth.haveAccount": "Déjà un compte ?",
    "auth.registerTitle": "Rejoindre BarPadi",
    "auth.registerSubtitle": "Choisissez comment vous travaillez",
    "auth.createBar": "Créer mon bar",
    "auth.createBarDesc": "Gérez commandes, stock, crédits et livraisons de votre bar.",
    "auth.createDist": "Inscrire un dépôt",
    "auth.createDistDesc": "Recevez les commandes des bars et suivez vos factures.",
    "auth.haveCode": "J'ai un code d'invitation",
    "auth.haveCodeDesc": "Rejoignez l'équipe d'un bar ou d'un dépôt existant.",
    "auth.yourDetails": "Vos informations",
    "auth.orgDetailsBar": "Votre bar",
    "auth.orgDetailsDist": "Votre dépôt",
    "auth.fullName": "Nom complet",
    "auth.orgName": "Nom de l'établissement",
    "auth.city": "Ville",
    "auth.quarter": "Quartier (optionnel)",
    "auth.inviteCode": "Code d'invitation",
    "auth.createAccount": "Créer mon compte",
    "auth.back": "Retour",
    "nav.dashboard": "Tableau de bord",
    "nav.orders": "Commandes",
    "nav.delivery": "Livraison à domicile",
    "nav.clients": "Clients",
    "nav.menu": "Menu & Stock",
    "nav.distributors": "Distributeurs",
    "nav.invoices": "Factures",
    "nav.reports": "Rapports",
    "nav.messages": "Messages",
    "nav.settings": "Paramètres",
    "nav.supplyOrders": "Commandes",
    "nav.deliveries": "Livraisons",
    "nav.partnerBars": "Bars partenaires",
    "nav.catalog": "Catalogue",
    "shell.notifications": "Notifications",
    "shell.noNotifications": "Aucune notification pour l'instant",
    "shell.logout": "Se déconnecter",
    "shell.joinTeam": "Rejoindre une équipe",
    "shell.joinTeamDesc": "Entrez le code à 6 caractères reçu de votre patron.",
    "shell.join": "Rejoindre",
    "shell.workspaces": "Espaces de travail",
    "team.title": "Équipe",
    "team.subtitle": "Membres et invitations de {org}",
    "team.members": "Membres",
    "team.invites": "Invitations",
    "team.invitePhone": "Téléphone du collègue",
    "team.inviteRole": "Rôle",
    "team.sendInvite": "Créer l'invitation",
    "team.code": "Code",
    "team.expires": "Expire",
    "team.revoke": "Révoquer",
    "team.deactivate": "Désactiver",
    "team.inactive": "Inactif",
    "team.codeHint": "Communiquez ce code à votre collègue (WhatsApp ou de vive voix). Valable 72 h.",
    "team.copied": "Code copié",
    "role.owner": "Patron",
    "role.bartender": "Barman",
    "role.dist_admin": "Admin dépôt",
    "role.dist_staff": "Staff dépôt",
    "role.platform_admin": "Admin plateforme",
    "status.pending": "En attente",
    "status.accepted": "Acceptée",
    "status.expired": "Expirée",
    "status.revoked": "Révoquée",
    "common.loading": "Chargement…",
    "common.save": "Enregistrer",
    "common.cancel": "Annuler",
    "common.details": "Détails",
    "nav.more": "Plus",
    "settings.dataSaver": "Économie de données",
    "settings.dataSaverDesc": "Réduit les actualisations automatiques pour économiser votre forfait internet",
    "terms.pay_before_dispatch": "Paiement avant expédition",
    "terms.pay_on_delivery": "Paiement à la livraison",
    "terms.on_credit": "À crédit (facture)",
    "supply.paymentTerms": "Conditions de paiement",
    "supply.termsPick": "Comment ce bar paiera-t-il ?",
    "supply.awaitingPayment": "⏳ En attente de paiement",
    "supply.requestPayment": "Demander le paiement 💬",
    "supply.changeTerms": "Modifier les conditions",
    "supply.termsProposed": "{by} propose : {terms}",
    "supply.termsSent": "Proposition envoyée au bar",
    "supply.termsUpdated": "Conditions mises à jour",
    "supply.savedRiders": "Livreurs enregistrés",
    "supply.newRider": "➕ Nouveau livreur",
    "riders.title": "Équipe de livraison",
    "riders.manageTeam": "Gérer l'équipe",
    "riders.add": "Ajouter un livreur",
    "riders.edit": "Modifier",
    "riders.save": "Enregistrer",
    "riders.saved": "Livreur enregistré ✓",
    "riders.search": "Rechercher par nom ou téléphone…",
    "riders.notePlaceholder": "Note (ex. moto rouge, couvre Bonabéri)",
    "riders.deliveries30d": "{n} livraisons (30 j)",
    "riders.lastDelivery": "Dernière : {date}",
    "riders.noDeliveryYet": "Aucune livraison",
    "riders.inactive": "Inactif",
    "riders.deactivate": "Désactiver",
    "riders.reactivate": "Réactiver",
    "riders.deactivated": "Livreur désactivé — il n'apparaîtra plus au dispatch",
    "riders.reactivated": "Livreur réactivé ✓",
    "riders.delete": "Supprimer",
    "riders.deleted": "Livreur supprimé",
    "riders.deleteConfirm": "Supprimer {name} ? Cette action est définitive.",
    "riders.duplicatePhone": "Un livreur avec ce numéro existe déjà",
    "riders.empty": "Aucun livreur. Ajoutez votre premier livreur !",
    "theme.light": "Thème clair",
    "theme.dark": "Thème sombre",
    "theme.system": "Thème système",
    "profile.paymentPolicy": "Politique de paiement",
    "profile.payFirst": "Payer d'abord 💰",
    "profile.payFirstDesc": "Encaisser avant de servir — recommandé",
    "profile.payLaterOpt": "Payer après",
    "profile.payLaterDesc": "Servir puis encaisser (ancien mode)",
    "profile.bartenderGift": "Les barmans peuvent offrir des boissons 🎁",
    "orders.payFirstLock": "Encaissez d'abord 💰",
    "orders.payFirstLockHint": "Cash, MoMo confirmé, crédit signé ou cadeau — puis servez",
    "orders.gift": "Offrir 🎁",
    "orders.giftTitle": "Offrir cette commande 🎁",
    "orders.giftDesc": "Le cadeau est enregistré comme promo au coût — jamais comme une vente.",
    "orders.giftReasonPh": "Raison (ex. anniversaire client fidèle)",
    "orders.giftConfirm": "Confirmer le cadeau 🎁",
    "orders.gifted": "🎁 Offert",
    "orders.giftDone": "Cadeau enregistré 🎁 — promo au coût créée",
    "reports.gifts": "🎁 Offerts",
    "reports.leaderboard": "Où coule l'argent",
    "reports.topProducts": "Meilleures ventes",
    "reports.busiestTables": "Tables les plus actives",
    "reports.bestHours": "Meilleures heures",
    "reports.counter": "Comptoir",
    "reports.ordersN": "{n} cmd",
    "pay.cashNow": "Cash à la commande 💵",
    "pay.cashNowDesc": "Payez le serveur avant le service",
    "pay.waitConfirm": "Vos boissons arrivent dès que le bar confirme votre paiement ✅",
    "consumer.payFirstHint": "Commandez, payez, et c'est servi 🍻",
    "ntf.venue.gift.title": "🎁 Cadeau offert par {by}",
    "ntf.venue.gift.body": "{reason} — valeur {total}, coût {cost}",
    "nav.reservations": "Réservations",
    "day.mon": "Lun", "day.tue": "Mar", "day.wed": "Mer", "day.thu": "Jeu",
    "day.fri": "Ven", "day.sat": "Sam", "day.sun": "Dim",
    "tables.reservable": "Réservable",
    "tables.seats": "Places",
    "tables.zone": "Zone (Terrasse, VIP…)",
    "resa.settingsTitle": "Réservations",
    "resa.settingsDesc": "Laissez les clients réserver une table depuis votre page publique.",
    "resa.enableToggle": "Activer les réservations en ligne",
    "resa.listToggle": "Afficher mon bar dans l'annuaire public 🌍",
    "resa.autoConfirmToggle": "Confirmation automatique des réservations",
    "resa.slotLength": "Durée d'un créneau :",
    "resa.hoursTitle": "Horaires d'ouverture (vide = fermé)",
    "resa.sectionTitle": "Réserver une table",
    "resa.sectionSub": "Gratuit, en 60 secondes — confirmation par SMS.",
    "resa.party": "Personnes :",
    "resa.partyN": "{n} pers.",
    "resa.closedDay": "Fermé ce jour — choisissez une autre date 🙏",
    "resa.pickTable": "Choisissez votre table (ou laissez-nous choisir)",
    "resa.anyTable": "N'importe quelle table pour {n}",
    "resa.reserved": "Réservée",
    "resa.yourName": "Votre nom",
    "resa.yourPhone": "Votre téléphone (WhatsApp)",
    "resa.notePh": "Note (anniversaire, coin calme…)",
    "resa.reserveBtn": "Réserver à {time} 🍻",
    "resa.otpSent": "Code envoyé par SMS 📲",
    "resa.otpDesc": "Entrez le code reçu au {phone}",
    "resa.otpCode": "Code SMS",
    "resa.confirmBtn": "Confirmer ma réservation ✅",
    "resa.bookedTitle": "Table réservée ! 🎉",
    "resa.bookedDesc": "Le {date} à {time} pour {n} pers. On vous attend 🍻",
    "resa.pendingTitle": "Demande envoyée ! 🕐",
    "resa.pendingDesc": "Le bar confirme votre réservation très vite — suivez le lien ci-dessous.",
    "resa.addToWa": "Garder dans mon WhatsApp",
    "resa.manageLink": "Voir / annuler ma réservation",
    "resa.waSelf": "🍻 Réservation {bar} — {date} à {time}, {n} pers. Gérer : {link}",
    "resa.waConfirm": "✅ {bar} : votre table pour {n} à {time} est confirmée ! À très vite 🍻 Gérer : {link}",
    "resa.cancelBtn": "Annuler ma réservation",
    "resa.cancelConfirm": "Annuler cette réservation ?",
    "resa.cancelled": "Réservation annulée",
    "resa.status.pending": "En attente",
    "resa.status.confirmed": "Confirmée",
    "resa.status.seated": "Installée ✓",
    "resa.status.cancelled": "Annulée",
    "resa.status.no_show": "Non venue",
    "resa.viewBar": "Voir le bar",
    "resa.dirTitle": "Trouvez votre bar 🍻",
    "resa.dirCity": "Bars à {city} 🍻",
    "resa.dirSub": "Réservez une table gratuitement, sans compte.",
    "resa.dirSearch": "Nom, ville, quartier…",
    "resa.dirEmpty": "Aucun bar trouvé pour l'instant.",
    "resa.openNow": "Ouvert",
    "resa.closedNow": "Fermé",
    "resa.reserve": "Réserver",
    "resa.manualAdd": "Nouvelle résa",
    "resa.create": "Créer la réservation",
    "resa.created": "Réservation créée ✓",
    "resa.confirmBtn2": "Confirmer",
    "resa.decline": "Refuser",
    "resa.declineReasonPh": "Raison du refus (envoyée au client)",
    "resa.seatNow": "Installer ✓",
    "resa.seatedToast": "Client installé — session ouverte 🍻",
    "resa.pendingSection": "À confirmer",
    "resa.emptyDay": "Aucune réservation ce jour.",
    "resa.disabledHint": "Les réservations en ligne sont désactivées — activez-les dans Réglages → Tables.",
    "resa.upsellDesc": "Prenez des réservations en ligne 24h/24 depuis votre page publique — passez au plan Padi.",
    "ntf.resa.new.title": "📅 Nouvelle réservation",
    "ntf.resa.new.body": "{client} — {party} pers. le {when}",
    "ntf.resa.cancelled.title": "❌ Réservation annulée",
    "ntf.resa.cancelled.body": "{client} — {party} pers.",
    "ntf.resa.risk.title": "⚠️ Risque de no-show",
    "ntf.resa.risk.body": "{client} ({party} pers.) n'est pas encore installé",
    "supply.sendJobWa": "Envoyer la mission au livreur 📱",
    "supply.dispatchedTitle": "Livreur en route ! 🚚",
    "supply.pendingCash": "💵 Espèces à réconcilier",
    "supply.confirmCash": "Confirmer réception espèces",
    "common.accept": "Accepter",
    "common.decline": "Refuser",
    "portal.title": "Mission de livraison",
    "portal.deliverTo": "Livrer à",
    "portal.total": "Total",
    "portal.emptiesToCollect": "{n} casier(s) vides à récupérer",
    "portal.pickedUp": "Colis récupéré 📦",
    "portal.arrived": "Arrivé au bar 🏁",
    "portal.deliveredBtn": "Livré ✓ — {n} casiers récupérés",
    "portal.emptiesCollected": "Casiers vides récupérés",
    "portal.paymentPanel": "💳 Paiement — montrez cet écran au bar",
    "portal.amountDue": "Montant à encaisser",
    "portal.reference": "Motif / référence",
    "portal.cash": "Espèces 💵",
    "portal.cashHint": "Encaissez exactement ce montant",
    "portal.paymentDone": "Paiement effectué ✓",
    "portal.pickMethod": "Sélectionnez le moyen utilisé puis validez.",
    "portal.missionComplete": "Mission terminée 🎉",
    "portal.expired": "Ce lien de livraison a expiré ou n'existe pas.",
    "portal.backSoon": "Contactez le dépôt si besoin.",
    "portal.action.picked_up": "Colis récupéré",
    "portal.action.arrived": "Livreur arrivé au bar",
    "portal.terms.banner.pay_on_delivery": "💵 Paiement à la livraison — encaissez avant de clôturer",
    "portal.terms.banner.pay_before_dispatch": "✅ Déjà payé avant expédition — ne rien encaisser",
    "portal.terms.banner.on_credit": "🧾 À crédit — ne rien encaisser",
    "ntf.payment.request.title": "💳 Paiement requis — {number}",
    "ntf.payment.request.body": "{dist_name} demande {amount} avant expédition",
    "ntf.supply.driver.title": "🚚 {action}",
    "ntf.supply.driver.body": "{rider} — {org_name}",
    "ntf.invoice.attach.title": "📎 Joignez votre reçu",
    "ntf.invoice.attach.body": "Facture {number} — ajoutez la capture du paiement ({amount})",
    "wa.orderMsg": "Bonjour {bar}, je veux commander :\n{lines}\nTotal : {total}\nNom : \nQuartier : ",
    "common.comingSoon": "Cette page arrive à l'étape {stage}.",
    "common.copy": "Copier",
    "auth.demoTitle": "Comptes de démonstration",
    "auth.demoTap": "Touchez pour remplir",
    "menu.title": "Menu & Stock",
    "menu.addItem": "Ajouter un article",
    "menu.stock": "Stock",
    "menu.fridge": "Frigo",
    "menu.cost": "Coût",
    "menu.sell": "Vente",
    "menu.margin": "Marge",
    "menu.crates": "{c} casiers + {u}",
    "menu.name": "Nom",
    "menu.category": "Catégorie",
    "menu.sizeLabel": "Format (ex : 65 cl)",
    "menu.unitsPerCrate": "Unités par casier",
    "menu.openingStock": "Stock de départ",
    "menu.sellOrMargin": "Renseignez le prix de vente OU la marge",
    "menu.deactivate": "Désactiver",
    "menu.activate": "Activer",
    "menu.delete": "Supprimer",
    "menu.deleteConfirm": "Supprimer définitivement cet article ?",
    "menu.inactive": "Inactif",
    "menu.deliveryTitle": "Enregistrer une livraison",
    "menu.deliveryDesc": "Course au marché ou dépôt — le stock et le coût sont mis à jour.",
    "menu.writeoffTitle": "Perte / Casse",
    "menu.writeoffDesc": "Bouteille cassée, perte ou offert — sorti du stock au coût.",
    "menu.item": "Article",
    "menu.qty": "Quantité",
    "menu.unitCost": "Coût unitaire",
    "menu.record": "Enregistrer",
    "menu.reason": "Motif",
    "menu.recent": "Dernières opérations",
    "menu.supplyLogged": "Livraison enregistrée",
    "menu.writeoffLogged": "Perte enregistrée",
    "menu.itemAdded": "Article ajouté",
    "reason.damage": "Casse",
    "reason.loss": "Perte",
    "reason.promo": "Promo / Offert",
    "cat.beer": "Bières",
    "cat.soft": "Softs",
    "cat.spirits": "Spiritueux",
    "cat.food": "Cuisine",
    "menu.lowStock": "Stock bas",
    "settings.team": "Équipe",
    "settings.tables": "Tables",
    "settings.payments": "Paiements",
    "tables.free": "Libre",
    "tables.since": "depuis",
    "pay.methodsTitle": "Moyens de paiement",
    "pay.methodsDesc": "Vos clients paient EN DEHORS de l'app puis envoient une preuve. Aucun paiement ne transite par BarPadi.",
    "pay.addMethod": "Ajouter un moyen",
    "pay.kind": "Type",
    "pay.label": "Libellé",
    "pay.accountName": "Nom du compte",
    "pay.accountNumber": "Numéro",
    "pay.instructions": "Instructions (texte libre)",
    "pay.externalUrl": "Lien externe (URL)",
    "pay.default": "Par défaut",
    "pay.active": "Actif",
    "pay.kind.mtn_momo": "MTN MoMo",
    "pay.kind.orange_money": "Orange Money",
    "pay.kind.bank": "Banque",
    "pay.kind.external_link": "Lien externe",
    "pay.kind.other": "Autre",
    "pay.sheetTitle": "Comment payer ?",
    "pay.cashLater": "Cash à la fin",
    "pay.cashLaterDesc": "Payez le serveur quand vous partez.",
    "pay.payNow": "Payer maintenant",
    "pay.payNowDesc": "Mobile money ou banque, puis envoyez la preuve.",
    "pay.credit": "Sur mon ardoise",
    "pay.creditSoon": "Le crédit arrive bientôt — accord signé requis.",
    "pay.chooseMethod": "Choisissez un moyen",
    "pay.openLink": "Ouvrir le lien de paiement",
    "pay.proofTitle": "Envoyer la preuve",
    "pay.proofDesc": "Payez d'abord, puis renseignez la référence et/ou une photo du reçu.",
    "pay.claimedAmount": "Montant payé",
    "pay.reference": "Référence de transaction",
    "pay.receiptPhoto": "Photo du reçu",
    "pay.submitProof": "Envoyer la preuve",
    "pay.proofSent": "Preuve envoyée — en attente de confirmation",
    "pay.confirmed": "Paiement confirmé 🎉",
    "pay.rejected": "Preuve rejetée : {reason}",
    "pay.resubmit": "Renvoyer une preuve",
    "pay.status.proof_submitted": "Preuve envoyée",
    "pay.status.confirmed": "Payé",
    "pay.status.rejected": "Preuve rejetée",
    "pay.reviewProof": "Vérifier la preuve",
    "pay.cashReceived": "Cash reçu",
    "pay.cashRecorded": "Cash enregistré",
    "pay.claimed": "Montant déclaré",
    "pay.ocrAmount": "Montant OCR",
    "pay.ocrReference": "Référence OCR",
    "pay.mismatch": "ATTENTION : le montant déclaré ne correspond pas au reçu lu ({ocr} F)",
    "pay.noOcr": "Lecture automatique du reçu non configurée (RECEIPT_READER=mock)",
    "pay.confirm": "Confirmer",
    "pay.reject": "Rejeter",
    "pay.rejectReason": "Motif du rejet",
    "pay.paid": "Payé",
    "pay.devOcr": "DEV : simuler une lecture OCR",
    "pay.devOcrAmount": "Montant OCR simulé",
    "credit.title": "Ardoise",
    "credit.gauge": "{open} / {limit} F",
    "credit.status.none": "Pas d'accord",
    "credit.status.pending": "Accord en attente",
    "credit.status.signed": "Accord signé",
    "credit.push": "Proposer l'ardoise 💬",
    "credit.pushed": "Lien de signature envoyé (WhatsApp)",
    "credit.limit": "Limite",
    "credit.viewAgreement": "Voir l'accord",
    "credit.debts": "Dettes ouvertes",
    "credit.noDebts": "Aucune dette ouverte",
    "credit.settle": "Encaisser",
    "credit.settled": "Dette(s) réglée(s)",
    "credit.remind": "Rappeler 💬",
    "credit.reminded": "Rappel envoyé (WhatsApp)",
    "credit.signTitle": "Accord d'ardoise",
    "credit.signAt": "chez {bar}",
    "credit.signIntro": "Pour ouvrir votre ardoise, vérifiez votre numéro puis signez l'accord.",
    "credit.verifyPhone": "Vérifier mon numéro",
    "credit.fullName": "Nom complet (comme sur la CNI)",
    "credit.cni": "Numéro de CNI",
    "credit.selfie": "Selfie",
    "credit.idPhoto": "Photo de la CNI",
    "credit.typedSignature": "Signature (tapez votre nom complet)",
    "credit.signBtn": "Je signe l'accord",
    "credit.signedOk": "Accord signé ! Limite : 10 000 F",
    "credit.signCard": "Votre accord d'ardoise vous attend — signez pour commander à crédit.",
    "credit.signNow": "Signer maintenant",
    "credit.creditOk": "Sur mon ardoise",
    "credit.creditDesc": "Ardoise : {open} / {limit} F",
    "credit.charged": "Ajouté à votre ardoise",
    "credit.err.credit_not_signed": "Accord d'ardoise non signé.",
    "credit.err.phone_not_verified": "Numéro non vérifié.",
    "credit.err.over_limit": "Limite d'ardoise dépassée.",
    "credit.aging": "J+{days}",
    "dash.hello": "Bonjour",
    "dash.today": "Aujourd'hui",
    "dash.sales": "Ventes",
    "dash.profit": "Bénéfice",
    "dash.orders": "Commandes servies",
    "dash.openSessions": "Clients en salle",
    "dash.pendingOrders": "Commandes en attente",
    "dash.pendingProofs": "Preuves à vérifier",
    "dash.lowStock": "Articles en stock bas",
    "dash.openDebts": "Ardoises ouvertes",
    "dash.viewReports": "Voir les rapports",
    "dash.outstanding": "Encours factures",
    "dash.overdue": "En retard",
    "dash.monthDelivered": "Livré ce mois",
    "dash.supplySoon": "Les commandes fournisseurs arrivent à l'étape 7.",
    "reports.title": "Rapports",
    "reports.today": "Aujourd'hui",
    "reports.week": "Semaine",
    "reports.month": "Mois",
    "reports.writeoffs": "Pertes / Casse",
    "reports.purchases": "Achats (livraisons)",
    "reports.paySplit": "Encaissements confirmés",
    "reports.cash": "Cash",
    "reports.mobile": "Mobile / Banque",
    "reports.credit": "Crédit (ardoise)",
    "reports.topItems": "Meilleures ventes",
    "reports.noSales": "Aucune vente sur la période.",
    "reports.dayClose": "Clôturer la journée",
    "reports.dayCloseDesc": "Fige les chiffres du jour et envoie le rapport WhatsApp au patron.",
    "reports.dayClosed": "Journée clôturée — rapport envoyé au patron 💬",
    "reports.alreadyClosed": "Journée clôturée",
    "reports.closes": "Clôtures récentes",
    "reports.csv": "Exporter CSV",
    "supply.pairTitle": "Jumelage bar ↔ dépôt",
    "supply.pairDesc": "Générez un code et partagez-le, ou entrez le code reçu de l'autre partie.",
    "supply.generateCode": "Générer un code",
    "supply.haveCode": "J'ai un code",
    "supply.codeHint": "Valable 72 h. Partagez-le par WhatsApp ou de vive voix.",
    "supply.paired": "Partenariat activé 🤝",
    "supply.awaitingPartner": "En attente du partenaire — code :",
    "supply.noPartners": "Aucun partenaire pour l'instant.",
    "supply.myPartners": "Mes bars partenaires",
    "supply.searchPartners": "Rechercher (nom, ville, quartier ou téléphone)",
    "supply.pfilter.all": "Tous",
    "supply.pfilter.active": "Actifs",
    "supply.pfilter.paused": "En pause",
    "supply.pfilter.outstanding": "Solde dû",
    "supply.pfilter.overdue": "En retard",
    "supply.noPartnerMatch": "Aucun partenaire ne correspond.",
    "supply.findBar": "Trouver un bar",
    "supply.findBarDesc": "Cherchez un bar inscrit sur BarPadi et demandez un jumelage.",
    "supply.searchDirectory": "Nom, ville ou quartier…",
    "supply.requestPairing": "Demander un jumelage",
    "supply.requested": "Demande envoyée — le bar recevra votre code",
    "supply.labelPaired": "Partenaire",
    "supply.labelInvited": "Invitation envoyée",
    "supply.dirEmpty": "Ce bar n'est pas encore sur BarPadi ? Envoyez-lui votre code d'invitation :",
    "supply.pstatus.active": "Actif",
    "supply.pstatus.paused": "En pause",
    "supply.pstatus.invited": "Invité",
    "supply.pause": "Mettre en pause",
    "supply.resume": "Réactiver",
    "supply.editTerms": "Modifier les conditions",
    "supply.terms": "Crédit {days} j",
    "supply.termsDays": "Jours de crédit",
    "supply.limitLabel": "Limite",
    "supply.outstanding": "Encours",
    "supply.order": "Commander",
    "supply.orderFrom": "Commande — {name}",
    "supply.freeformPh": "Article libre (ex : glace)…",
    "supply.empties": "Casiers vides à rendre",
    "supply.notes": "Notes",
    "supply.placeOrder": "Passer la commande",
    "supply.orderPlaced": "Commande envoyée au dépôt",
    "supply.overLimitWarn": "Limite de crédit dépassée — le dépôt devra approuver.",
    "supply.overLimit": "Hors limite",
    "supply.myOrders": "Mes commandes fournisseurs",
    "supply.noOrders": "Aucune commande pour l'instant.",
    "supply.noDeliveries": "Aucune livraison pour l'instant.",
    "supply.cancelled": "Commande annulée",
    "supply.cancelReason": "Motif d'annulation ?",
    "supply.confirm": "Confirmer",
    "supply.approveConfirm": "Approuver & confirmer",
    "supply.markReady": "Prête",
    "supply.markDelivered": "Livrée ✓",
    "supply.dispatch": "Expédier",
    "supply.dispatched": "En route 🚚",
    "supply.driverName": "Nom du chauffeur",
    "supply.driverPhone": "Téléphone du chauffeur",
    "supply.vehicleNote": "Véhicule (optionnel)",
    "supply.unitPrice": "Prix unitaire",
    "supply.unit.crate12": "Casier ×12",
    "supply.unit.crate6": "Casier ×6",
    "supply.unit.carton": "Carton",
    "supply.unit.unit": "Unité",
    "supply.status.placed": "Passée",
    "supply.status.confirmed": "Confirmée",
    "supply.status.ready": "Prête",
    "supply.status.out_for_delivery": "En livraison",
    "supply.status.delivered": "Livrée",
    "supply.status.received": "Réceptionnée",
    "supply.status.cancelled": "Annulée",
    "supply.receiveTitle": "Réceptionner la livraison",
    "supply.receiveDesc": "Associez chaque ligne à un article de votre stock — quantités en unités.",
    "supply.receiveBtn": "Réceptionner",
    "supply.received": "Livraison réceptionnée — stock mis à jour 📦",
    "supply.receiveIncomplete": "Complétez chaque ligne (article + prix de vente) ou ignorez-la.",
    "supply.skipLine": "Ignorer",
    "supply.chooseBarItem": "Choisir un article…",
    "supply.newItem": "Nouvel article",
    "supply.qtyUnits": "Unités reçues",
    "inv.payTitle": "Payer la facture",
    "inv.pay": "Payer",
    "inv.remaining": "Reste :",
    "inv.due": "Échéance",
    "inv.empty": "Aucune facture pour l'instant.",
    "inv.status.unpaid": "Impayée",
    "inv.status.partially_paid": "Partielle",
    "inv.status.paid": "Payée",
    "inv.status.overdue": "En retard",
    "inv.aging": "Balance âgée",
    "inv.current": "À échoir",
    "inv.recordCash": "Encaisser cash",
    "inv.cashPrompt": "Montant reçu en cash ?",
    "dash.trend": "14 derniers jours",
    "dash.hdPending": "Livraisons en cours",
    "dash.invoicesOwing": "Factures à payer",
    "hd.settingsTitle": "Livraison à domicile",
    "hd.enabled": "Activée",
    "hd.fee": "Frais de livraison",
    "hd.minOrder": "Commande min.",
    "hd.zones": "Zones desservies (note)",
    "hd.copyLink": "Copier le lien boutique",
    "hd.disabled": "La livraison à domicile n'est pas disponible pour ce bar.",
    "hd.checkout": "Commander",
    "hd.placeOrder": "Envoyer la commande",
    "hd.address": "Adresse de livraison",
    "hd.landmark": "Repère (ex : face pharmacie)",
    "hd.belowMin": "Commande minimum : {min} F",
    "hd.cashOnDelivery": "Paiement cash à la livraison.",
    "hd.trackTitle": "Suivi de commande",
    "hd.status.placed": "Reçue",
    "hd.status.confirmed": "Confirmée",
    "hd.status.preparing": "En préparation",
    "hd.status.out_for_delivery": "En route",
    "hd.status.delivered": "Livrée",
    "hd.status.cancelled": "Annulée",
    "hd.confirm": "Confirmer",
    "hd.startPrep": "Préparer",
    "hd.markDelivered": "Livrée ✓",
    "hd.dispatch": "Envoyer le livreur",
    "hd.rider": "Livreur",
    "hd.riderName": "Nom du livreur",
    "hd.riderPhone": "Téléphone du livreur",
    "hd.empty": "Aucune commande à domicile pour l'instant.",
    "hd.waShare": "Partager sur WhatsApp",
    "hd.waShareText": "🍻 Commandez vos boissons, on vous livre à domicile ! 👉 {link}",
    "supply.emptiesOwed": "{n} casiers vides à rendre",
    "supply.emptiesReceived": "Casiers reçus",
    "supply.emptiesPrompt": "Combien de casiers vides reçus ?",
    "supply.emptiesRecorded": "Casiers enregistrés 🍾",
    "reports.distDayClosed": "Journée clôturée — rapport dépôt envoyé 💬",
    "reports.distDayCloseDesc": "Fige la journée du dépôt et envoie le récap WhatsApp à l'admin.",
    "settings.profile": "Page publique",
    "settings.security": "Sécurité",
    "pin.title": "Code PIN propriétaire",
    "pin.desc": "Protégez les rapports, la clôture et les limites d'ardoise quand le téléphone circule.",
    "pin.active": "PIN actif sur ce compte",
    "pin.newPin": "Nouveau PIN (4–6 chiffres)",
    "pin.confirmPassword": "Mot de passe du compte",
    "pin.set": "Activer le PIN",
    "pin.change": "Changer le PIN",
    "pin.remove": "Supprimer le PIN",
    "pin.saved": "PIN enregistré 🔒",
    "pin.removed": "PIN supprimé",
    "pin.passwordNeeded": "Entrez votre mot de passe pour confirmer.",
    "pin.gateTitle": "Zone protégée",
    "pin.gateDesc": "Entrez votre code PIN pour continuer.",
    "pin.unlock": "Déverrouiller",
    "pin.wrong": "PIN incorrect",
    "pin.tooMany": "Trop de tentatives — réessayez dans quelques minutes.",
    "pin.promptMsg": "Code PIN propriétaire :",
    "profile.title": "Page publique du bar",
    "profile.desc": "Votre vitrine partageable : menu, horaires et itinéraire.",
    "profile.quarter": "Quartier",
    "profile.hours": "Horaires",
    "profile.maps": "Lien Google Maps",
    "profile.about": "À propos",
    "profile.aboutPh": "Le spot le plus frais du quartier…",
    "profile.view": "Voir la page",
    "profile.directions": "Itinéraire",
    "profile.orderCta": "Commander à domicile",
    "profile.menuTitle": "Notre carte",
    "profile.footer": "La carte et les prix sont gérés par le bar.",
    "profile.waText": "🍻 Découvrez notre bar — carte, horaires et itinéraire : {link}",
    "dash.delivered": "Livré",
    "dash.collected": "Encaissé",
    "messages.title": "Messages",
    "messages.desc": "Messages WhatsApp sortants (mode démo — aucun envoi réel).",
    "messages.empty": "Aucun message pour l'instant.",
    "messages.digest": "Envoyer le résumé du jour",
    "messages.weekly": "Récap hebdo",
    "messages.weeklySent": "Récap hebdomadaire envoyé aux propriétaires",
    "messages.digestSent": "Résumé envoyé",
    "messages.status.queued": "En file",
    "messages.status.sent": "Envoyé",
    "messages.status.failed": "Échec",
    "tables.title": "Tables & QR",
    "tables.add": "Ajouter une table",
    "tables.number": "Numéro",
    "tables.label": "Libellé (ex : Terrasse)",
    "tables.print": "Imprimer la feuille QR",
    "tables.copy": "Copier le lien",
    "tables.copied": "Lien copié",
    "tables.active": "Active",
    "tables.scanMe": "Scannez pour commander",
    "tables.publicQr": "Page publique & menu",
    "tables.scanPublic": "Scannez pour voir notre menu",
    "clients.title": "Clients",
    "clients.checkinTitle": "Check-in comptoir",
    "clients.checkinDesc": "Enregistrez un client et ouvrez sa session.",
    "clients.name": "Nom (si nouveau)",
    "clients.table": "Table",
    "clients.counter": "Comptoir",
    "clients.checkin": "Ouvrir la session",
    "clients.checkedIn": "Session ouverte",
    "clients.inHouse": "En salle",
    "clients.closeSession": "Clôturer",
    "clients.sessionClosed": "Session clôturée",
    "clients.search": "Rechercher (nom ou téléphone)",
    "nav.overview": "Vue d'ensemble",
    "nav.adminBars": "Bars",
    "nav.adminDists": "Distributeurs",
    "nav.accounts": "Comptes",
    "nav.subscriptions": "Abonnements",
    "nav.revenue": "Revenus",
    "nav.announcements": "Annonces",
    "nav.audit": "Journal d'audit",
    "shell.impersonating": "Connecté en tant que {name} (mode admin)",
    "shell.stopImpersonating": "Revenir à l'admin",
    "billing.title": "Abonnement",
    "billing.currentPlan": "Plan actuel",
    "billing.renewsOn": "renouvellement le",
    "billing.comingSoon": "L'abonnement arrive bientôt — revenez plus tard !",
    "billing.monthly": "Mensuel",
    "billing.annual": "Annuel",
    "billing.save": "Économisez {amount}",
    "billing.twoFree": "2 mois offerts",
    "billing.free": "Gratuit",
    "billing.unlimited": "Illimité",
    "billing.creditClients": "clients à crédit",
    "billing.reports_today": "Rapports du jour",
    "billing.reports_week": "Rapports jour + semaine",
    "billing.reports_full": "Rapports complets",
    "billing.yourPlan": "Votre plan",
    "billing.choose": "Choisir",
    "billing.history": "Historique de facturation",
    "billing.howPay": "Comment souhaitez-vous payer ?",
    "billing.usualMethod": "Votre méthode habituelle",
    "billing.hint.mtn_momo": "Paiement depuis votre téléphone",
    "billing.hint.orange_money": "Paiement depuis votre téléphone",
    "billing.hint.bank": "Virement depuis votre banque",
    "billing.hint.external_link": "Paiement en ligne",
    "billing.hint.other": "Autre méthode",
    "billing.waInstructions": "Recevoir les instructions sur WhatsApp",
    "billing.waSent": "Instructions envoyées sur WhatsApp",
    "billing.openPayPage": "Ouvrir la page de paiement",
    "billing.transferRef": "Motif du transfert",
    "billing.claimedAmount": "Montant payé (F)",
    "billing.txRef": "Référence de transaction",
    "billing.receipt": "Photo du reçu",
    "billing.submitProof": "Envoyer la preuve",
    "billing.proofSent": "Preuve envoyée — vérification en cours",
    "billing.pendingBanner": "Preuve reçue — vérification en cours (généralement sous 24h)",
    "billing.pendingCancelled": "Preuve annulée",
    "billing.cancelResubmit": "Annuler / renvoyer une preuve",
    "billing.rejectedReason": "Preuve rejetée",
    "billing.downgradeConfirm": "Passer au plan Starter ? Vos données restent intactes, mais les fonctionnalités au-delà des limites Starter passeront en lecture seule.",
    "billing.downgraded": "Plan Starter activé",
    "billing.pastDueBanner": "Abonnement expiré — il vous reste {days} jours avant le passage en lecture seule.",
    "billing.readOnlyBanner": "Abonnement en lecture seule — vos données sont visibles, renouvelez pour réactiver les modifications.",
    "billing.renewNow": "Renouveler",
    "billing.upsellDesc": "Disponible avec le plan {plan}. Passez au niveau supérieur en 2 minutes.",
    "billing.seeplans": "Voir les plans",
    "feat.max_staff": "Ajoutez plus de membres d'équipe",
    "feat.table_qr_tables": "Ajoutez plus de tables QR",
    "feat.credit_clients_limit": "Plus de clients à crédit",
    "feat.reports_level": "Rapports complets (mois et plus)",
    "feat.csv_export": "Export CSV",
    "feat.home_delivery": "Livraison à domicile",
    "feat.whatsapp_features": "Fonctions WhatsApp",
    "feat.multi_bar_view": "Vue multi-bars",
    "feat.reservations": "Réservations de tables",
    "feat.subscription": "Abonnement",
    "admin.noMethodsWarning": "Aucune méthode de paiement plateforme configurée — les bars ne peuvent pas s'abonner.",
    "admin.bars": "Bars",
    "admin.dists": "Distributeurs",
    "admin.consumers": "Consommateurs",
    "admin.activeToday": "Actifs aujourd'hui",
    "admin.ordersToday": "Commandes aujourd'hui",
    "admin.sessionsToday": "Sessions aujourd'hui",
    "admin.paying": "Payants",
    "admin.ordersPerDay": "Commandes / jour (30j)",
    "admin.gmvPerWeek": "GMV / semaine",
    "admin.orgsPerWeek": "Nouvelles orgs / semaine",
    "admin.planMix": "Répartition des plans",
    "admin.topBars": "Top 10 bars actifs (30j)",
    "admin.churnRisk": "Risque de churn (payants inactifs 7j+)",
    "admin.noChurn": "Aucun risque détecté",
    "admin.latestSignups": "Dernières inscriptions",
    "admin.adoption": "Adoption des fonctionnalités",
    "admin.suspended": "Suspendu",
    "admin.lastActive": "actif le",
    "admin.trialExtended": "Essai prolongé de 14 jours",
    "admin.priceOverride": "Prix spécial (F/mois)",
    "admin.founderPrice": "Prix fondateur",
    "admin.extendTrial": "Prolonger l'essai 14j",
    "admin.usage14d": "Activité (14 jours)",
    "admin.deleteConfirm": "IRRÉVERSIBLE — tapez le nom exact « {name} » pour confirmer la suppression :",
    "admin.deleted": "Organisation supprimée",
    "admin.unsuspend": "Réactiver l'organisation",
    "admin.suspend": "Suspendre l'organisation",
    "admin.exportJson": "Exporter (JSON)",
    "admin.deleteOrg": "Supprimer / anonymiser",
    "admin.oneTimePwd": "Mot de passe temporaire pour {name} (copiez-le maintenant) :",
    "admin.disabled": "Désactivé",
    "admin.resetPwd": "Réinit. mot de passe",
    "admin.enable": "Réactiver",
    "admin.deactivate": "Désactiver",
    "admin.signInAs": "Se connecter en tant que…",
    "admin.pendingProofs": "Preuves à vérifier",
    "admin.noProofs": "Aucune preuve en attente",
    "admin.proofConfirmed": "Abonnement activé 🎉",
    "admin.rejectReason": "Raison du rejet :",
    "admin.reminderSent": "Rappel WhatsApp envoyé",
    "admin.dunning": "Relances (past due)",
    "admin.daysLeft": "{days} jours restants",
    "admin.remind": "Relancer",
    "admin.allSubs": "Tous les abonnements",
    "admin.proofPending": "preuve en attente",
    "admin.expected": "attendu",
    "admin.revenueByMonth": "Revenus par mois (paiements confirmés)",
    "admin.allBars": "Tous les bars",
    "admin.allDists": "Tous les distributeurs",
    "admin.plan": "Plan",
    "admin.publish": "Publier",
    "admin.auditSearch": "Rechercher (action, admin, cible…)",
    "admin.tab.plans": "Plans & droits",
    "admin.tab.methods": "Méthodes de paiement",
    "admin.tab.templates": "Modèles WhatsApp",
    "admin.tab.flags": "Feature flags",
    "admin.plansWarning": "Les changements s'appliquent immédiatement à tous les bars du plan.",
    "admin.planSaved": "Plan enregistré — appliqué immédiatement",
    "clients.filter.all": "Tous",
    "clients.filter.checked_in": "Présents",
    "clients.filter.open_debts": "Dettes ouvertes",
    "clients.filter.credit_signed": "Crédit signé",
    "clients.filter.no_credit": "Sans crédit",
    "clients.sort.recent": "Activité récente",
    "clients.sort.name": "Nom A–Z",
    "clients.sort.debt": "Dette la plus élevée",
    "clients.noMatch": "Aucun client ne correspond — vérifiez le numéro ou enregistrez-le au comptoir ci-dessus.",
    "clients.debtShort": "Dette",
    "common.prev": "Précédent",
    "common.next": "Suivant",
    "clients.verified": "Vérifié",
    "orders.title": "Commandes",
    "orders.live": "En direct",
    "orders.history": "Historique",
    "orders.music": "Musique",
    "orders.markServed": "Marquer servi",
    "orders.done": "Fait",
    "orders.served": "Servi",
    "orders.request": "Demande",
    "orders.empty": "Aucune commande en attente — tout roule.",
    "orders.songEmpty": "Aucune chanson demandée.",
    "orders.played": "Jouée",
    "orders.dismiss": "Ignorer",
    "bring.now": "Maintenant",
    "bring.min10": "~10 min",
    "bring.min20": "~20 min",
    "bring.with_food": "Avec le repas",
    "req.ice": "Glaçons",
    "req.waiter": "Serveur",
    "req.serviettes": "Serviettes",
    "req.chairs": "Chaises",
    "req.piment": "Piment",
    "notify.markAll": "Tout marquer lu",
    "notify.mute": "Couper le son",
    "notify.unmute": "Activer le son",
    "consumer.welcome": "Bienvenue chez",
    "consumer.table": "Table",
    "consumer.continueAs": "Continuer comme {name} ? (…{last2})",
    "consumer.confirmPhone": "Confirmez votre numéro complet",
    "consumer.resume": "Reprendre ma session",
    "consumer.newSession": "Nouvelle session",
    "consumer.checkinTitle": "Installez-vous",
    "consumer.checkinDesc": "Votre numéro pour ouvrir votre table.",
    "consumer.nameLabel": "Votre nom",
    "consumer.start": "C'est parti",
    "consumer.otpTitle": "Code de vérification",
    "consumer.otpDesc": "Entrez le code reçu par SMS au {phone}.",
    "consumer.otpDev": "MODE DÉMO — code : {code}",
    "consumer.verify": "Vérifier",
    "consumer.menuTitle": "La carte",
    "consumer.finished": "épuisé",
    "consumer.myOrders": "Mes commandes",
    "consumer.orderBtn": "Commander · {total}",
    "consumer.orderSent": "Commande envoyée !",
    "consumer.orderServed": "Votre commande est servie 🎉",
    "consumer.requests": "Besoin de quelque chose ?",
    "consumer.requestSent": "Demande envoyée",
    "consumer.song": "Une chanson ?",
    "consumer.songPlaceholder": "Titre ou artiste…",
    "consumer.songSent": "Demande de chanson envoyée",
    "consumer.bringWhen": "Quand ?",
    "consumer.payLater": "Vous payez à la fin — tranquille.",
    "consumer.status.new": "En préparation",
    "consumer.status.served": "Servi",
    "consumer.status.cancelled": "Annulé",
    "pay.kind.cash": "Cash",
    "billing.ref": "réf",
    "common.invalidJson": "JSON invalide",
    "consumer.smsUnavailable": "Vérification SMS indisponible",
    "admin.adopt.table_qr": "🪑 Tables QR",
    "admin.adopt.credit": "💳 Crédit",
    "admin.adopt.pairing": "🚚 Jumelage",
    "admin.adopt.home_delivery": "🛵 Livraison",
    "admin.perMonth": "/mois",
    "admin.perYear": "/an",
    "admin.isPublic": "public",
    "admin.tplHint": "Ces messages WhatsApp sont envoyés dans la langue du destinataire — remplissez les deux versions.",
    "supply.status.changes_proposed": "Modifs proposées",
    "supply.timeline": "Historique & discussion",
    "supply.desiredDate": "Date souhaitée",
    "supply.diffTitle": "Modifications proposées",
    "supply.newLine": "Nouvelle ligne",
    "supply.removedLine": "Supprimée",
    "supply.unavailable": "Indisponible",
    "supply.proposeReplacement": "Proposer un remplacement",
    "supply.proposeChanges": "Proposer des modifications",
    "supply.editOrder": "Modifier la commande",
    "supply.proposeNote": "Note (ex : rupture de stock…)",
    "supply.proposeSave": "Envoyer la proposition",
    "supply.proposeSent": "Proposition envoyée",
    "supply.acceptProposal": "Accepter la proposition",
    "supply.declineEdit": "Décliner / modifier",
    "supply.proposalAccepted": "Proposition acceptée ✅",
    "supply.frozen": "En attente de la réponse de l'autre partie…",
    "supply.addLine": "Ajouter une ligne",
    "supply.commentPh": "Écrire un commentaire…",
    "supply.ev.comment": "Commentaire",
    "supply.ev.edited": "Commande modifiée",
    "supply.ev.proposed": "Modifications proposées",
    "supply.ev.proposal_accepted": "Proposition acceptée",
    "supply.ev.proposal_declined": "Proposition déclinée",
    "supply.ev.terms_proposed": "Changement de conditions proposé",
    "supply.ev.terms_accepted": "Conditions acceptées",
    "supply.ev.terms_declined": "Conditions refusées",
    "supply.ev.driver_payment": "Paiement encaissé par le livreur",
    "portal.step.dispatched": "Expédié",
    "portal.step.picked_up": "Récupéré",
    "portal.step.arrived": "Arrivé",
    "portal.step.completed": "Livré",
    "time.justNow": "à l'instant",
    "time.minAgo": "il y a {m} min",
    "time.hourAgo": "il y a {h} h",
    "ntf.order.new.title": "Nouvelle commande — {table}",
    "ntf.order.new.body": "{client} : {summary} · {total}",
    "ntf.request.new.title": "Demande — {table}",
    "ntf.request.new.body": "{client} : {request_type}",
    "ntf.song.new.title": "Demande de chanson",
    "ntf.song.new.body": "{client} : {text}",
    "ntf.checkin.new.title": "Arrivée — {table}",
    "ntf.checkin.new.body": "{client} vient de s'installer",
    "ntf.payment.proof.title": "Preuve de paiement reçue",
    "ntf.payment.proof.body": "{amount} par {method_kind} — à vérifier",
    "ntf.payment.proof.mismatch": " ⚠️ montant OCR différent",
    "ntf.supply.placed.title": "Nouvelle commande — {bar_name}",
    "ntf.supply.placed.body": "{total}",
    "ntf.supply.placed.overLimit": " ⚠️ limite crédit dépassée — approbation requise",
    "ntf.supply.received.title": "Commande réceptionnée",
    "ntf.supply.received.body": "{total} — le bar a réceptionné la livraison",
    "ntf.supply.status.title": "Commande {status} — {dist_name}",
    "ntf.supply.status.body": "{total}",
    "ntf.invoice.new.title": "Nouvelle facture — {dist_name}",
    "ntf.invoice.new.body": "{number} · {amount}",
    "ntf.hd.new.title": "Livraison à domicile — {client}",
    "ntf.hd.new.body": "{total} · {address}",
    "ntf.partnership.request.title": "Demande de partenariat — {dist_name}",
    "ntf.partnership.request.body": "Code de jumelage : {code} — acceptez-le dans Distributeurs",
    "ntf.supply.update.comment": "💬 Nouveau commentaire",
    "ntf.supply.update.proposed": "✏️ {actor_name} propose des modifications",
    "ntf.supply.update.proposal_accepted": "✅ Proposition acceptée",
    "ntf.supply.update.proposal_declined": "↩️ Proposition déclinée — commande modifiée",
    "ntf.supply.update.edited": "✏️ Commande modifiée par le bar",
    "ntf.supply.update.default": "Commande mise à jour",
    "ntf.supply.update.body": "{actor_name} — {text}",
    "ntf.credit.signed.title": "Accord de crédit signé",
    "ntf.credit.signed.body": "{client} a signé son accord d'ardoise",
    "ntf.digest.daily.title": "Résumé du jour envoyé",
    "ntf.digest.daily.body": "✅ {confirmed} · ⏳ {pending} · ❌ {rejected}",
    "ntf.day.closed.title": "Journée clôturée",
    "ntf.day.closed.body": "Ventes {sales} · Bénéfice {profit} — rapport envoyé au patron",
    "ntf.day.closed.dist.title": "Journée clôturée",
    "ntf.day.closed.dist.body": "Livraisons {deliveries} · Encaissé {collected} — rapport envoyé",
    "ntf.billing.active.title": "Abonnement {plan} actif 🎉",
    "ntf.billing.active.body": "Valable jusqu'au {date}",
    "ntf.billing.rejected.title": "Preuve d'abonnement rejetée",
    "ntf.billing.rejected.body": "{reason}",
    "ntf.billing.renewal.title": "Renouvellement d'abonnement",
    "ntf.billing.renewal.body": "Votre plan {plan} expire dans {days} j — renouvelez pour garder vos fonctionnalités",
    "money.perMonth": "/mois",
    "money.perYear": "/an",
    "common.total": "Total",
    "consumer.tableNotFound": "Table introuvable",
    "credit.linkNotFound": "Lien introuvable",
    "admin.level.info": "Info",
    "admin.level.warning": "Alerte",
    "admin.annFrPh": "Message (FR)",
    "admin.annEnPh": "Message (EN)",
    "pin.digitsPh": "4–6 chiffres",
    "profile.hoursPh": "Lun–Dim · 10h – 02h",
    "inv.colBar": "Bar",
    "inv.age1": "1–15 j",
    "inv.age2": "16–30 j",
    "inv.age3": "30+ j",
    "sub.status.trial": "Essai",
    "sub.status.active": "Actif",
    "sub.status.past_due": "En retard",
    "sub.status.read_only": "Lecture seule",
    "sub.status.pending_payment": "Preuve en attente",
    "billing.staff": "staff",
    "billing.tablesQr": "tables QR",
    "admin.d7": "7 j",
    "admin.d30": "30 j",
    "sync.synced": "Synchronisé",
    "sync.syncing": "Synchronisation…",
    "sync.offlinePending": "Hors ligne — {n} en attente",
    "sync.pendingShort": "{n} à synchroniser",
    "sync.savedOffline": "Enregistré hors ligne — sera synchronisé au retour du réseau",
    "sync.needsConnection": "Connexion requise — cette page sera disponible au retour du réseau",
    "sync.provisional": "Provisoire — en attente de synchronisation",
    "sync.issuesTitle": "Synchronisation",
    "sync.issuesDesc": "Conflits et actions hors ligne à vérifier — le serveur reste la référence",
    "sync.noIssues": "Aucun problème de synchronisation",
    "sync.resolve": "OK, vu",
    "sync.retry": "Réessayer",
    "sync.deadEvents": "{n} action(s) n'ont pas pu être synchronisées",
    "sync.updateReady": "Nouvelle version disponible",
    "sync.refresh": "Actualiser",
    "sync.toVerify": "à vérifier",
    "sync.issue.stockNegative": "Stock de {item} passé en négatif ({stock}) — comptez le frigo",
    "sync.issue.sessionAlreadyClosed": "La session de {client} était déjà clôturée",
    "sync.issue.closedWithPending": "Session de {client} clôturée avec {count} commande(s) non servie(s)",
    "sync.issue.duplicateCash": "Paiement cash en double ignoré ({amount})",
    "sync.issue.alreadyServed": "Commande déjà servie — action ignorée",
    "sync.issue.failedEvent": "Action « {type} » a échoué : {error}",
    "sheet.title": "Commande — {client}",
    "sheet.submitOrder": "Envoyer la commande",
    "sheet.orderSent": "Commande enregistrée ✓",
    "sheet.requestSent": "Demande envoyée ✓",
    "sheet.newOrderBtn": "+ Commande",
    "clients.nameRequired": "Nom requis pour un nouveau client",
    "clients.phoneInvalid": "Numéro de téléphone invalide",
    "wa.remind": "Rappel ardoise",
    "wa.message": "Message",
    "wa.contact": "Contact",
    "wa.contactDepot": "Contacter le dépôt",
    "wa.share": "Partager sur WhatsApp",
    "wa.sendReport": "📱 Envoyer le rapport sur mon WhatsApp",
    "wa.sendInvite": "Envoyer sur WhatsApp",
    "wa.help": "Aide sur WhatsApp 💬",
    "wa.orderOnWa": "Commander sur WhatsApp",
    "wa.sendLocation": "📍 Ou envoyez votre position sur WhatsApp",
    "wa.requestLocation": "Demander la position 📍",
    "wa.notifyCustomer": "Prévenir le client 📱",
    "wa.sendJobDriver": "Envoyer la course au livreur 📱",
    "wa.driverTip": "Astuce : demandez au livreur de partager sa position en direct dans votre discussion WhatsApp pour suivre la livraison.",
    "wa.contactDriver": "Livreur",
    "wa.contactCustomer": "Client",
    "wa.remindInvoice": "Relancer",
    "wa.statement": "Relance solde",
    "wa.renewalRemind": "Relancer sur WhatsApp",
    "wa.marketingOptIn": "OK pour recevoir les promos de {bar} sur WhatsApp",
    "wa.kitTitle": "WhatsApp Kit 💬",
    "wa.kitDesc": "Tout pour vendre plus avec WhatsApp — gratuit, sans configuration",
    "wa.statusGen": "Images pour votre Statut WhatsApp",
    "wa.statusStory": "Story 1080×1920",
    "wa.statusSquare": "Carré 1080×1080",
    "wa.designOrder": "Commandez de chez vous 🍻",
    "wa.designTable": "Scannez, commandez à table ✨",
    "wa.customLine": "Ligne personnalisée (ex : Match ce soir — écran géant !)",
    "wa.download": "Télécharger",
    "wa.shareMyBar": "Partager ma boutique",
    "wa.copyLink": "Copier le lien",
    "wa.copied": "Lien copié ✓",
    "wa.downloadQr": "Télécharger le QR (PNG)",
    "wa.channelSection": "Numéro & chaîne WhatsApp",
    "wa.waNumber": "Numéro WhatsApp du bar",
    "wa.waNumberDist": "Numéro WhatsApp",
    "wa.channelUrl": "Lien de votre chaîne WhatsApp",
    "wa.waOrderToggle": "Bouton « Commander sur WhatsApp » sur la boutique",
    "wa.howtoTitle": "WhatsApp pro en 4 étapes",
    "wa.howto1": "1. Créez un profil WhatsApp Business avec le nom du bar",
    "wa.howto2": "2. Renseignez vos horaires et votre adresse",
    "wa.howto3": "3. Créez une chaîne WhatsApp et collez le lien ici",
    "wa.howto4": "4. Publiez votre image de Statut chaque week-end",
    "wa.followBarpadi": "Suivre BarPadi",
    "wa.followChannel": "Chaîne officielle BarPadi 📢",
    "wa.supportChat": "Support BarPadi 💬",
    "wa.shareCatalog": "Partager mes tarifs",
    "wa.invitePartner": "Inviter un bar partenaire",
    "wa.followBar": "Suivez {bar} sur WhatsApp 📢",
    "wa.supportNumber": "Numéro WhatsApp du support",
    "wa.barpadiChannel": "Lien de la chaîne BarPadi",
    "settings.whatsappKit": "WhatsApp Kit 💬",
    "settings.whatsapp": "WhatsApp 💬",
    "wa.helpOpenerText": "Bonjour BarPadi 👋 J'ai besoin d'aide.",
    "wa.seePairing": "(voir Réglages → Jumelage)",
  },
  en: {
    "auth.welcome": "Welcome back",
    "auth.loginSubtitle": "Sign in to your workspace",
    "auth.phone": "Phone number",
    "auth.password": "Password",
    "auth.login": "Sign in",
    "auth.google": "Continue with Google",
    "auth.googleSoon": "Available soon",
    "auth.noAccount": "No account?",
    "auth.register": "Create an account",
    "auth.haveAccount": "Already have an account?",
    "auth.registerTitle": "Join BarPadi",
    "auth.registerSubtitle": "Choose how you work",
    "auth.createBar": "Create my bar",
    "auth.createBarDesc": "Run your bar's orders, stock, credit and deliveries.",
    "auth.createDist": "Register a distributor",
    "auth.createDistDesc": "Receive orders from bars and track your invoices.",
    "auth.haveCode": "I have an invite code",
    "auth.haveCodeDesc": "Join the team of an existing bar or depot.",
    "auth.yourDetails": "Your details",
    "auth.orgDetailsBar": "Your bar",
    "auth.orgDetailsDist": "Your depot",
    "auth.fullName": "Full name",
    "auth.orgName": "Business name",
    "auth.city": "City",
    "auth.quarter": "Quarter (optional)",
    "auth.inviteCode": "Invite code",
    "auth.createAccount": "Create my account",
    "auth.back": "Back",
    "nav.dashboard": "Dashboard",
    "nav.orders": "Orders",
    "nav.delivery": "Home Delivery",
    "nav.clients": "Clients",
    "nav.menu": "Menu & Stock",
    "nav.distributors": "Distributors",
    "nav.invoices": "Invoices",
    "nav.reports": "Reports",
    "nav.messages": "Messages",
    "nav.settings": "Settings",
    "nav.supplyOrders": "Supply Orders",
    "nav.deliveries": "Deliveries",
    "nav.partnerBars": "Partner Bars",
    "nav.catalog": "Catalog",
    "shell.notifications": "Notifications",
    "shell.noNotifications": "No notifications yet",
    "shell.logout": "Sign out",
    "shell.joinTeam": "Join a team",
    "shell.joinTeamDesc": "Enter the 6-character code your boss gave you.",
    "shell.join": "Join",
    "shell.workspaces": "Workspaces",
    "team.title": "Team",
    "team.subtitle": "Members and invites of {org}",
    "team.members": "Members",
    "team.invites": "Invites",
    "team.invitePhone": "Colleague's phone",
    "team.inviteRole": "Role",
    "team.sendInvite": "Create invite",
    "team.code": "Code",
    "team.expires": "Expires",
    "team.revoke": "Revoke",
    "team.deactivate": "Deactivate",
    "team.inactive": "Inactive",
    "team.codeHint": "Share this code with your colleague (WhatsApp or in person). Valid 72h.",
    "team.copied": "Code copied",
    "role.owner": "Owner",
    "role.bartender": "Bartender",
    "role.dist_admin": "Depot admin",
    "role.dist_staff": "Depot staff",
    "role.platform_admin": "Platform admin",
    "status.pending": "Pending",
    "status.accepted": "Accepted",
    "status.expired": "Expired",
    "status.revoked": "Revoked",
    "common.loading": "Loading…",
    "common.save": "Save",
    "common.cancel": "Cancel",
    "common.details": "Details",
    "nav.more": "More",
    "settings.dataSaver": "Data saver",
    "settings.dataSaverDesc": "Reduces background refreshes to save your data bundle",
    "terms.pay_before_dispatch": "Payment before dispatch",
    "terms.pay_on_delivery": "Pay the driver on delivery",
    "terms.on_credit": "On credit (invoice)",
    "supply.paymentTerms": "Payment terms",
    "supply.termsPick": "How will this bar pay?",
    "supply.awaitingPayment": "⏳ Awaiting payment",
    "supply.requestPayment": "Request payment 💬",
    "supply.changeTerms": "Change terms",
    "supply.termsProposed": "{by} proposes: {terms}",
    "supply.termsSent": "Proposal sent to the bar",
    "supply.termsUpdated": "Terms updated",
    "supply.savedRiders": "Saved riders",
    "supply.newRider": "➕ New rider",
    "riders.title": "Delivery team",
    "riders.manageTeam": "Manage team",
    "riders.add": "Add rider",
    "riders.edit": "Edit",
    "riders.save": "Save",
    "riders.saved": "Rider saved ✓",
    "riders.search": "Search by name or phone…",
    "riders.notePlaceholder": "Note (e.g. red bike, covers Bonabéri)",
    "riders.deliveries30d": "{n} deliveries (30d)",
    "riders.lastDelivery": "Last: {date}",
    "riders.noDeliveryYet": "No deliveries yet",
    "riders.inactive": "Inactive",
    "riders.deactivate": "Deactivate",
    "riders.reactivate": "Reactivate",
    "riders.deactivated": "Rider deactivated — hidden from dispatch",
    "riders.reactivated": "Rider reactivated ✓",
    "riders.delete": "Delete",
    "riders.deleted": "Rider deleted",
    "riders.deleteConfirm": "Delete {name}? This cannot be undone.",
    "riders.duplicatePhone": "A rider with this phone already exists",
    "riders.empty": "No riders yet. Add your first rider!",
    "theme.light": "Light theme",
    "theme.dark": "Dark theme",
    "theme.system": "System theme",
    "profile.paymentPolicy": "Payment policy",
    "profile.payFirst": "Pay first 💰",
    "profile.payFirstDesc": "Collect before serving — recommended",
    "profile.payLaterOpt": "Pay later",
    "profile.payLaterDesc": "Serve then collect (legacy mode)",
    "profile.bartenderGift": "Bartenders can offer drinks 🎁",
    "orders.payFirstLock": "Collect payment first 💰",
    "orders.payFirstLockHint": "Cash, confirmed MoMo, signed credit or gift — then serve",
    "orders.gift": "Offer 🎁",
    "orders.giftTitle": "Offer this order as a gift 🎁",
    "orders.giftDesc": "Gifts are recorded as promos at cost — never as sales.",
    "orders.giftReasonPh": "Reason (e.g. loyal client's birthday)",
    "orders.giftConfirm": "Confirm gift 🎁",
    "orders.gifted": "🎁 Gift",
    "orders.giftDone": "Gift recorded 🎁 — promo write-off created",
    "reports.gifts": "🎁 Gifts",
    "reports.leaderboard": "Where the money flows",
    "reports.topProducts": "Best sellers",
    "reports.busiestTables": "Busiest tables",
    "reports.bestHours": "Best hours",
    "reports.counter": "Counter",
    "reports.ordersN": "{n} orders",
    "pay.cashNow": "Cash at order 💵",
    "pay.cashNowDesc": "Pay the waiter before service",
    "pay.waitConfirm": "Your drinks arrive as soon as the bar confirms your payment ✅",
    "consumer.payFirstHint": "Order, pay, and it's served 🍻",
    "ntf.venue.gift.title": "🎁 Gift offered by {by}",
    "ntf.venue.gift.body": "{reason} — value {total}, cost {cost}",
    "nav.reservations": "Reservations",
    "day.mon": "Mon", "day.tue": "Tue", "day.wed": "Wed", "day.thu": "Thu",
    "day.fri": "Fri", "day.sat": "Sat", "day.sun": "Sun",
    "tables.reservable": "Reservable",
    "tables.seats": "Seats",
    "tables.zone": "Zone (Terrace, VIP…)",
    "resa.settingsTitle": "Reservations",
    "resa.settingsDesc": "Let clients book a table from your public page.",
    "resa.enableToggle": "Enable online reservations",
    "resa.listToggle": "List my bar in the public directory 🌍",
    "resa.autoConfirmToggle": "Auto-confirm bookings",
    "resa.slotLength": "Slot length:",
    "resa.hoursTitle": "Opening hours (empty = closed)",
    "resa.sectionTitle": "Reserve a table",
    "resa.sectionSub": "Free, takes 60 seconds — SMS confirmation.",
    "resa.party": "Guests:",
    "resa.partyN": "{n} guests",
    "resa.closedDay": "Closed that day — pick another date 🙏",
    "resa.pickTable": "Pick your table (or let us choose)",
    "resa.anyTable": "Any table for {n}",
    "resa.reserved": "Reserved",
    "resa.yourName": "Your name",
    "resa.yourPhone": "Your phone (WhatsApp)",
    "resa.notePh": "Note (birthday, quiet corner…)",
    "resa.reserveBtn": "Reserve at {time} 🍻",
    "resa.otpSent": "SMS code sent 📲",
    "resa.otpDesc": "Enter the code sent to {phone}",
    "resa.otpCode": "SMS code",
    "resa.confirmBtn": "Confirm my booking ✅",
    "resa.bookedTitle": "Table booked! 🎉",
    "resa.bookedDesc": "{date} at {time} for {n} guests. See you there 🍻",
    "resa.pendingTitle": "Request sent! 🕐",
    "resa.pendingDesc": "The bar will confirm shortly — track it with the link below.",
    "resa.addToWa": "Keep in my WhatsApp",
    "resa.manageLink": "View / cancel my booking",
    "resa.waSelf": "🍻 Booking {bar} — {date} at {time}, {n} guests. Manage: {link}",
    "resa.waConfirm": "✅ {bar}: your table for {n} at {time} is confirmed! See you soon 🍻 Manage: {link}",
    "resa.cancelBtn": "Cancel my booking",
    "resa.cancelConfirm": "Cancel this booking?",
    "resa.cancelled": "Booking cancelled",
    "resa.status.pending": "Pending",
    "resa.status.confirmed": "Confirmed",
    "resa.status.seated": "Seated ✓",
    "resa.status.cancelled": "Cancelled",
    "resa.status.no_show": "No-show",
    "resa.viewBar": "View bar",
    "resa.dirTitle": "Find your bar 🍻",
    "resa.dirCity": "Bars in {city} 🍻",
    "resa.dirSub": "Book a table for free, no account needed.",
    "resa.dirSearch": "Name, city, quarter…",
    "resa.dirEmpty": "No bars found yet.",
    "resa.openNow": "Open",
    "resa.closedNow": "Closed",
    "resa.reserve": "Reserve",
    "resa.manualAdd": "New booking",
    "resa.create": "Create booking",
    "resa.created": "Booking created ✓",
    "resa.confirmBtn2": "Confirm",
    "resa.decline": "Decline",
    "resa.declineReasonPh": "Decline reason (shown to the client)",
    "resa.seatNow": "Seat now ✓",
    "resa.seatedToast": "Client seated — session opened 🍻",
    "resa.pendingSection": "To confirm",
    "resa.emptyDay": "No reservations that day.",
    "resa.disabledHint": "Online reservations are off — enable them in Settings → Tables.",
    "resa.upsellDesc": "Take bookings 24/7 from your public page — upgrade to the Padi plan.",
    "ntf.resa.new.title": "📅 New reservation",
    "ntf.resa.new.body": "{client} — {party} guests on {when}",
    "ntf.resa.cancelled.title": "❌ Reservation cancelled",
    "ntf.resa.cancelled.body": "{client} — {party} guests",
    "ntf.resa.risk.title": "⚠️ No-show risk",
    "ntf.resa.risk.body": "{client} ({party} guests) not seated yet",
    "supply.sendJobWa": "Send job to driver 📱",
    "supply.dispatchedTitle": "Driver on the way! 🚚",
    "supply.pendingCash": "💵 Cash to reconcile",
    "supply.confirmCash": "Confirm cash received",
    "common.accept": "Accept",
    "common.decline": "Decline",
    "portal.title": "Delivery mission",
    "portal.deliverTo": "Deliver to",
    "portal.total": "Total",
    "portal.emptiesToCollect": "{n} empty crate(s) to collect",
    "portal.pickedUp": "Picked up 📦",
    "portal.arrived": "Arrived at bar 🏁",
    "portal.deliveredBtn": "Delivered ✓ — {n} empties collected",
    "portal.emptiesCollected": "Empty crates collected",
    "portal.paymentPanel": "💳 Payment — show this screen to the bar",
    "portal.amountDue": "Amount to collect",
    "portal.reference": "Reference",
    "portal.cash": "Cash 💵",
    "portal.cashHint": "Collect exactly this amount",
    "portal.paymentDone": "Payment completed ✓",
    "portal.pickMethod": "Select the method used, then confirm.",
    "portal.missionComplete": "Mission complete 🎉",
    "portal.expired": "This delivery link has expired or does not exist.",
    "portal.backSoon": "Contact the depot if needed.",
    "portal.action.picked_up": "Package picked up",
    "portal.action.arrived": "Driver arrived at the bar",
    "portal.terms.banner.pay_on_delivery": "💵 Pay on delivery — collect before closing",
    "portal.terms.banner.pay_before_dispatch": "✅ Already paid before dispatch — collect nothing",
    "portal.terms.banner.on_credit": "🧾 On credit — collect nothing",
    "ntf.payment.request.title": "💳 Payment required — {number}",
    "ntf.payment.request.body": "{dist_name} requests {amount} before dispatch",
    "ntf.supply.driver.title": "🚚 {action}",
    "ntf.supply.driver.body": "{rider} — {org_name}",
    "ntf.invoice.attach.title": "📎 Attach your receipt",
    "ntf.invoice.attach.body": "Invoice {number} — add the payment screenshot ({amount})",
    "wa.orderMsg": "Hello {bar}, I would like to order:\n{lines}\nTotal: {total}\nName: \nNeighbourhood: ",
    "common.comingSoon": "This page arrives in stage {stage}.",
    "common.copy": "Copy",
    "auth.demoTitle": "Demo accounts",
    "auth.demoTap": "Tap to fill",
    "menu.title": "Menu & Stock",
    "menu.addItem": "Add item",
    "menu.stock": "Stock",
    "menu.fridge": "Fridge",
    "menu.cost": "Cost",
    "menu.sell": "Sell",
    "menu.margin": "Margin",
    "menu.crates": "{c} crates + {u}",
    "menu.name": "Name",
    "menu.category": "Category",
    "menu.sizeLabel": "Size (e.g. 65 cl)",
    "menu.unitsPerCrate": "Units per crate",
    "menu.openingStock": "Opening stock",
    "menu.sellOrMargin": "Fill in the sell price OR the margin",
    "menu.deactivate": "Deactivate",
    "menu.activate": "Activate",
    "menu.delete": "Delete",
    "menu.deleteConfirm": "Permanently delete this item?",
    "menu.inactive": "Inactive",
    "menu.deliveryTitle": "Record a delivery",
    "menu.deliveryDesc": "Market run or depot drop — stock and cost get updated.",
    "menu.writeoffTitle": "Write-off",
    "menu.writeoffDesc": "Broken bottle, loss or giveaway — removed from stock at cost.",
    "menu.item": "Item",
    "menu.qty": "Quantity",
    "menu.unitCost": "Unit cost",
    "menu.record": "Record",
    "menu.reason": "Reason",
    "menu.recent": "Recent activity",
    "menu.supplyLogged": "Delivery recorded",
    "menu.writeoffLogged": "Write-off recorded",
    "menu.itemAdded": "Item added",
    "reason.damage": "Damage",
    "reason.loss": "Loss",
    "reason.promo": "Promo / Giveaway",
    "cat.beer": "Beers",
    "cat.soft": "Softs",
    "cat.spirits": "Spirits",
    "cat.food": "Food",
    "menu.lowStock": "Low stock",
    "settings.team": "Team",
    "settings.tables": "Tables",
    "settings.payments": "Payments",
    "tables.free": "Free",
    "tables.since": "since",
    "pay.methodsTitle": "Payment methods",
    "pay.methodsDesc": "Your clients pay OUTSIDE the app then submit proof. No money flows through BarPadi.",
    "pay.addMethod": "Add a method",
    "pay.kind": "Type",
    "pay.label": "Label",
    "pay.accountName": "Account name",
    "pay.accountNumber": "Number",
    "pay.instructions": "Instructions (free text)",
    "pay.externalUrl": "External link (URL)",
    "pay.default": "Default",
    "pay.active": "Active",
    "pay.kind.mtn_momo": "MTN MoMo",
    "pay.kind.orange_money": "Orange Money",
    "pay.kind.bank": "Bank",
    "pay.kind.external_link": "External link",
    "pay.kind.other": "Other",
    "pay.sheetTitle": "How to pay?",
    "pay.cashLater": "Cash when served",
    "pay.cashLaterDesc": "Pay the waiter when you leave.",
    "pay.payNow": "Pay now",
    "pay.payNowDesc": "Mobile money or bank, then send the proof.",
    "pay.credit": "On my tab",
    "pay.creditSoon": "Credit is coming soon — signed agreement required.",
    "pay.chooseMethod": "Choose a method",
    "pay.openLink": "Open payment link",
    "pay.proofTitle": "Send proof",
    "pay.proofDesc": "Pay first, then enter the reference and/or a photo of the receipt.",
    "pay.claimedAmount": "Amount paid",
    "pay.reference": "Transaction reference",
    "pay.receiptPhoto": "Receipt photo",
    "pay.submitProof": "Submit proof",
    "pay.proofSent": "Proof sent — awaiting confirmation",
    "pay.confirmed": "Payment confirmed 🎉",
    "pay.rejected": "Proof rejected: {reason}",
    "pay.resubmit": "Resubmit proof",
    "pay.status.proof_submitted": "Proof sent",
    "pay.status.confirmed": "Paid",
    "pay.status.rejected": "Proof rejected",
    "pay.reviewProof": "Review proof",
    "pay.cashReceived": "Cash received",
    "pay.cashRecorded": "Cash recorded",
    "pay.claimed": "Claimed amount",
    "pay.ocrAmount": "OCR amount",
    "pay.ocrReference": "OCR reference",
    "pay.mismatch": "WARNING: claimed amount does not match the receipt reading ({ocr} F)",
    "pay.noOcr": "Automatic receipt reading not configured (RECEIPT_READER=mock)",
    "pay.confirm": "Confirm",
    "pay.reject": "Reject",
    "pay.rejectReason": "Rejection reason",
    "pay.paid": "Paid",
    "pay.devOcr": "DEV: simulate OCR reading",
    "pay.devOcrAmount": "Simulated OCR amount",
    "credit.title": "Tab",
    "credit.gauge": "{open} / {limit} F",
    "credit.status.none": "No agreement",
    "credit.status.pending": "Agreement pending",
    "credit.status.signed": "Agreement signed",
    "credit.push": "Offer a tab 💬",
    "credit.pushed": "Signing link sent (WhatsApp)",
    "credit.limit": "Limit",
    "credit.viewAgreement": "View agreement",
    "credit.debts": "Open debts",
    "credit.noDebts": "No open debts",
    "credit.settle": "Record payment",
    "credit.settled": "Debt(s) settled",
    "credit.remind": "Remind 💬",
    "credit.reminded": "Reminder sent (WhatsApp)",
    "credit.signTitle": "Tab agreement",
    "credit.signAt": "at {bar}",
    "credit.signIntro": "To open your tab, verify your number then sign the agreement.",
    "credit.verifyPhone": "Verify my number",
    "credit.fullName": "Full legal name (as on ID)",
    "credit.cni": "National ID number",
    "credit.selfie": "Selfie",
    "credit.idPhoto": "ID card photo",
    "credit.typedSignature": "Signature (type your full name)",
    "credit.signBtn": "I sign the agreement",
    "credit.signedOk": "Agreement signed! Limit: 10,000 F",
    "credit.signCard": "Your tab agreement is waiting — sign to order on credit.",
    "credit.signNow": "Sign now",
    "credit.creditOk": "On my tab",
    "credit.creditDesc": "Tab: {open} / {limit} F",
    "credit.charged": "Added to your tab",
    "credit.err.credit_not_signed": "Tab agreement not signed.",
    "credit.err.phone_not_verified": "Phone not verified.",
    "credit.err.over_limit": "Tab limit exceeded.",
    "credit.aging": "D+{days}",
    "dash.hello": "Hello",
    "dash.today": "Today",
    "dash.sales": "Sales",
    "dash.profit": "Profit",
    "dash.orders": "Orders served",
    "dash.openSessions": "Clients in house",
    "dash.pendingOrders": "Pending orders",
    "dash.pendingProofs": "Proofs to review",
    "dash.lowStock": "Low stock items",
    "dash.openDebts": "Open tabs",
    "dash.viewReports": "View reports",
    "dash.outstanding": "Invoices outstanding",
    "dash.overdue": "Overdue",
    "dash.monthDelivered": "Delivered this month",
    "dash.supplySoon": "Supply orders arrive in stage 7.",
    "reports.title": "Reports",
    "reports.today": "Today",
    "reports.week": "Week",
    "reports.month": "Month",
    "reports.writeoffs": "Write-offs",
    "reports.purchases": "Purchases (deliveries)",
    "reports.paySplit": "Confirmed payments",
    "reports.cash": "Cash",
    "reports.mobile": "Mobile / Bank",
    "reports.credit": "Credit (tab)",
    "reports.topItems": "Best sellers",
    "reports.noSales": "No sales in this period.",
    "reports.dayClose": "Close the day",
    "reports.dayCloseDesc": "Locks today's numbers and sends the WhatsApp report to the owner.",
    "reports.dayClosed": "Day closed — report sent to the owner 💬",
    "reports.alreadyClosed": "Day closed",
    "reports.closes": "Recent closes",
    "reports.csv": "Export CSV",
    "supply.pairTitle": "Bar ↔ depot pairing",
    "supply.pairDesc": "Generate a code and share it, or enter the code you received from the other side.",
    "supply.generateCode": "Generate a code",
    "supply.haveCode": "I have a code",
    "supply.codeHint": "Valid 72h. Share it via WhatsApp or in person.",
    "supply.paired": "Partnership activated 🤝",
    "supply.awaitingPartner": "Awaiting partner — code:",
    "supply.noPartners": "No partners yet.",
    "supply.myPartners": "My partner bars",
    "supply.searchPartners": "Search (name, city, quarter or phone)",
    "supply.pfilter.all": "All",
    "supply.pfilter.active": "Active",
    "supply.pfilter.paused": "Paused",
    "supply.pfilter.outstanding": "Outstanding balance",
    "supply.pfilter.overdue": "Overdue",
    "supply.noPartnerMatch": "No partner matches.",
    "supply.findBar": "Find a bar",
    "supply.findBarDesc": "Search bars registered on BarPadi and request a pairing.",
    "supply.searchDirectory": "Name, city or quarter…",
    "supply.requestPairing": "Request pairing",
    "supply.requested": "Request sent — the bar will receive your code",
    "supply.labelPaired": "Partner",
    "supply.labelInvited": "Invite sent",
    "supply.dirEmpty": "Bar not on BarPadi yet? Send them your invite code:",
    "supply.pstatus.active": "Active",
    "supply.pstatus.paused": "Paused",
    "supply.pstatus.invited": "Invited",
    "supply.pause": "Pause",
    "supply.resume": "Resume",
    "supply.editTerms": "Edit terms",
    "supply.terms": "Credit {days}d",
    "supply.termsDays": "Credit days",
    "supply.limitLabel": "Limit",
    "supply.outstanding": "Outstanding",
    "supply.order": "Order",
    "supply.orderFrom": "Order — {name}",
    "supply.freeformPh": "Free item (e.g. ice)…",
    "supply.empties": "Empty crates to return",
    "supply.notes": "Notes",
    "supply.placeOrder": "Place order",
    "supply.orderPlaced": "Order sent to the depot",
    "supply.overLimitWarn": "Credit limit exceeded — the depot must approve.",
    "supply.overLimit": "Over limit",
    "supply.myOrders": "My supply orders",
    "supply.noOrders": "No orders yet.",
    "supply.noDeliveries": "No deliveries yet.",
    "supply.cancelled": "Order cancelled",
    "supply.cancelReason": "Cancellation reason?",
    "supply.confirm": "Confirm",
    "supply.approveConfirm": "Approve & confirm",
    "supply.markReady": "Ready",
    "supply.markDelivered": "Delivered ✓",
    "supply.dispatch": "Dispatch",
    "supply.dispatched": "On the way 🚚",
    "supply.driverName": "Driver name",
    "supply.driverPhone": "Driver phone",
    "supply.vehicleNote": "Vehicle (optional)",
    "supply.unitPrice": "Unit price",
    "supply.unit.crate12": "Crate ×12",
    "supply.unit.crate6": "Crate ×6",
    "supply.unit.carton": "Carton",
    "supply.unit.unit": "Unit",
    "supply.status.placed": "Placed",
    "supply.status.confirmed": "Confirmed",
    "supply.status.ready": "Ready",
    "supply.status.out_for_delivery": "Out for delivery",
    "supply.status.delivered": "Delivered",
    "supply.status.received": "Received",
    "supply.status.cancelled": "Cancelled",
    "supply.receiveTitle": "Receive the delivery",
    "supply.receiveDesc": "Map each line to an item in your stock — quantities in units.",
    "supply.receiveBtn": "Receive",
    "supply.received": "Delivery received — stock updated 📦",
    "supply.receiveIncomplete": "Complete each line (item + sell price) or skip it.",
    "supply.skipLine": "Skip",
    "supply.chooseBarItem": "Choose an item…",
    "supply.newItem": "New item",
    "supply.qtyUnits": "Units received",
    "inv.payTitle": "Pay the invoice",
    "inv.pay": "Pay",
    "inv.remaining": "Remaining:",
    "inv.due": "Due",
    "inv.empty": "No invoices yet.",
    "inv.status.unpaid": "Unpaid",
    "inv.status.partially_paid": "Partial",
    "inv.status.paid": "Paid",
    "inv.status.overdue": "Overdue",
    "inv.aging": "Aging statement",
    "inv.current": "Not due",
    "inv.recordCash": "Record cash",
    "inv.cashPrompt": "Cash amount received?",
    "dash.trend": "Last 14 days",
    "dash.hdPending": "Deliveries in progress",
    "dash.invoicesOwing": "Invoices to pay",
    "hd.settingsTitle": "Home delivery",
    "hd.enabled": "Enabled",
    "hd.fee": "Delivery fee",
    "hd.minOrder": "Min. order",
    "hd.zones": "Delivery zones (note)",
    "hd.copyLink": "Copy shop link",
    "hd.disabled": "Home delivery is not available for this bar.",
    "hd.checkout": "Order",
    "hd.placeOrder": "Send order",
    "hd.address": "Delivery address",
    "hd.landmark": "Landmark (e.g. opposite pharmacy)",
    "hd.belowMin": "Minimum order: {min} F",
    "hd.cashOnDelivery": "Cash payment on delivery.",
    "hd.trackTitle": "Order tracking",
    "hd.status.placed": "Received",
    "hd.status.confirmed": "Confirmed",
    "hd.status.preparing": "Preparing",
    "hd.status.out_for_delivery": "On the way",
    "hd.status.delivered": "Delivered",
    "hd.status.cancelled": "Cancelled",
    "hd.confirm": "Confirm",
    "hd.startPrep": "Prepare",
    "hd.markDelivered": "Delivered ✓",
    "hd.dispatch": "Send the rider",
    "hd.rider": "Rider",
    "hd.riderName": "Rider name",
    "hd.riderPhone": "Rider phone",
    "hd.empty": "No home delivery orders yet.",
    "hd.waShare": "Share on WhatsApp",
    "hd.waShareText": "🍻 Order your drinks, we deliver to your door! 👉 {link}",
    "supply.emptiesOwed": "{n} empty crates to return",
    "supply.emptiesReceived": "Crates received",
    "supply.emptiesPrompt": "How many empty crates received?",
    "supply.emptiesRecorded": "Crates recorded 🍾",
    "reports.distDayClosed": "Day closed — depot report sent 💬",
    "reports.distDayCloseDesc": "Locks the depot's day and sends the WhatsApp recap to the admin.",
    "settings.profile": "Public page",
    "settings.security": "Security",
    "pin.title": "Owner PIN code",
    "pin.desc": "Protect reports, day close and tab limits when the phone is shared.",
    "pin.active": "PIN active on this account",
    "pin.newPin": "New PIN (4–6 digits)",
    "pin.confirmPassword": "Account password",
    "pin.set": "Enable PIN",
    "pin.change": "Change PIN",
    "pin.remove": "Remove PIN",
    "pin.saved": "PIN saved 🔒",
    "pin.removed": "PIN removed",
    "pin.passwordNeeded": "Enter your password to confirm.",
    "pin.gateTitle": "Protected area",
    "pin.gateDesc": "Enter your PIN code to continue.",
    "pin.unlock": "Unlock",
    "pin.wrong": "Wrong PIN",
    "pin.tooMany": "Too many attempts — try again in a few minutes.",
    "pin.promptMsg": "Owner PIN code:",
    "profile.title": "Public bar page",
    "profile.desc": "Your shareable showcase: menu, hours and directions.",
    "profile.quarter": "Quarter",
    "profile.hours": "Opening hours",
    "profile.maps": "Google Maps link",
    "profile.about": "About",
    "profile.aboutPh": "The freshest spot in the neighbourhood…",
    "profile.view": "View page",
    "profile.directions": "Directions",
    "profile.orderCta": "Order home delivery",
    "profile.menuTitle": "Our menu",
    "profile.footer": "Menu and prices are managed by the bar.",
    "profile.waText": "🍻 Discover our bar — menu, hours and directions: {link}",
    "dash.delivered": "Delivered",
    "dash.collected": "Collected",
    "messages.title": "Messages",
    "messages.desc": "Outgoing WhatsApp messages (demo mode — nothing really sent).",
    "messages.empty": "No messages yet.",
    "messages.digest": "Send today's digest",
    "messages.weekly": "Weekly recap",
    "messages.weeklySent": "Weekly recap sent to owners",
    "messages.digestSent": "Digest sent",
    "messages.status.queued": "Queued",
    "messages.status.sent": "Sent",
    "messages.status.failed": "Failed",
    "tables.title": "Tables & QR",
    "tables.add": "Add a table",
    "tables.number": "Number",
    "tables.label": "Label (e.g. Terrace)",
    "tables.print": "Print QR sheet",
    "tables.copy": "Copy link",
    "tables.copied": "Link copied",
    "tables.active": "Active",
    "tables.scanMe": "Scan to order",
    "tables.publicQr": "Public page & menu",
    "tables.scanPublic": "Scan to see our menu",
    "clients.title": "Clients",
    "clients.checkinTitle": "Counter check-in",
    "clients.checkinDesc": "Register a client and open their session.",
    "clients.name": "Name (if new)",
    "clients.table": "Table",
    "clients.counter": "Counter",
    "clients.checkin": "Open session",
    "clients.checkedIn": "Session opened",
    "clients.inHouse": "In house",
    "clients.closeSession": "Close",
    "clients.sessionClosed": "Session closed",
    "clients.search": "Search (name or phone)",
    "nav.overview": "Overview",
    "nav.adminBars": "Bars",
    "nav.adminDists": "Distributors",
    "nav.accounts": "Accounts",
    "nav.subscriptions": "Subscriptions",
    "nav.revenue": "Revenue",
    "nav.announcements": "Announcements",
    "nav.audit": "Audit log",
    "shell.impersonating": "Signed in as {name} (admin mode)",
    "shell.stopImpersonating": "Back to admin",
    "billing.title": "Subscription",
    "billing.currentPlan": "Current plan",
    "billing.renewsOn": "renews on",
    "billing.comingSoon": "Subscriptions are coming soon — check back later!",
    "billing.monthly": "Monthly",
    "billing.annual": "Annual",
    "billing.save": "Save {amount}",
    "billing.twoFree": "2 months free",
    "billing.free": "Free",
    "billing.unlimited": "Unlimited",
    "billing.creditClients": "credit clients",
    "billing.reports_today": "Today's reports",
    "billing.reports_week": "Day + week reports",
    "billing.reports_full": "Full reports",
    "billing.yourPlan": "Your plan",
    "billing.choose": "Choose",
    "billing.history": "Billing history",
    "billing.howPay": "How would you like to pay?",
    "billing.usualMethod": "Your usual method",
    "billing.hint.mtn_momo": "Pay from your phone",
    "billing.hint.orange_money": "Pay from your phone",
    "billing.hint.bank": "Transfer from your bank",
    "billing.hint.external_link": "Pay online",
    "billing.hint.other": "Other method",
    "billing.waInstructions": "Get the instructions on WhatsApp",
    "billing.waSent": "Instructions sent on WhatsApp",
    "billing.openPayPage": "Open the payment page",
    "billing.transferRef": "Transfer reference",
    "billing.claimedAmount": "Amount paid (F)",
    "billing.txRef": "Transaction reference",
    "billing.receipt": "Receipt photo",
    "billing.submitProof": "Submit proof",
    "billing.proofSent": "Proof sent — under review",
    "billing.pendingBanner": "Proof received — review in progress (usually within 24h)",
    "billing.pendingCancelled": "Proof cancelled",
    "billing.cancelResubmit": "Cancel / resubmit a proof",
    "billing.rejectedReason": "Proof rejected",
    "billing.downgradeConfirm": "Switch to Starter? Your data stays intact, but features beyond Starter limits become read-only.",
    "billing.downgraded": "Starter plan activated",
    "billing.pastDueBanner": "Subscription expired — {days} days left before read-only mode.",
    "billing.readOnlyBanner": "Subscription in read-only — your data is visible, renew to re-enable changes.",
    "billing.renewNow": "Renew",
    "billing.upsellDesc": "Available with the {plan} plan. Upgrade in 2 minutes.",
    "billing.seeplans": "See plans",
    "feat.max_staff": "Add more team members",
    "feat.table_qr_tables": "Add more QR tables",
    "feat.credit_clients_limit": "More credit clients",
    "feat.reports_level": "Full reports (month and more)",
    "feat.csv_export": "CSV export",
    "feat.home_delivery": "Home delivery",
    "feat.whatsapp_features": "WhatsApp features",
    "feat.multi_bar_view": "Multi-bar view",
    "feat.reservations": "Table reservations",
    "feat.subscription": "Subscription",
    "admin.noMethodsWarning": "No platform payment method configured — bars cannot subscribe.",
    "admin.bars": "Bars",
    "admin.dists": "Distributors",
    "admin.consumers": "Consumers",
    "admin.activeToday": "Active today",
    "admin.ordersToday": "Orders today",
    "admin.sessionsToday": "Sessions today",
    "admin.paying": "Paying",
    "admin.ordersPerDay": "Orders / day (30d)",
    "admin.gmvPerWeek": "GMV / week",
    "admin.orgsPerWeek": "New orgs / week",
    "admin.planMix": "Plan mix",
    "admin.topBars": "Top 10 active bars (30d)",
    "admin.churnRisk": "Churn risk (paying, inactive 7d+)",
    "admin.noChurn": "No risk detected",
    "admin.latestSignups": "Latest sign-ups",
    "admin.adoption": "Feature adoption",
    "admin.suspended": "Suspended",
    "admin.lastActive": "active",
    "admin.trialExtended": "Trial extended by 14 days",
    "admin.priceOverride": "Price override (F/month)",
    "admin.founderPrice": "Founder price",
    "admin.extendTrial": "Extend trial 14d",
    "admin.usage14d": "Activity (14 days)",
    "admin.deleteConfirm": "IRREVERSIBLE — type the exact name \"{name}\" to confirm deletion:",
    "admin.deleted": "Organization deleted",
    "admin.unsuspend": "Reactivate organization",
    "admin.suspend": "Suspend organization",
    "admin.exportJson": "Export (JSON)",
    "admin.deleteOrg": "Delete / anonymise",
    "admin.oneTimePwd": "One-time password for {name} (copy it now):",
    "admin.disabled": "Disabled",
    "admin.resetPwd": "Reset password",
    "admin.enable": "Re-enable",
    "admin.deactivate": "Deactivate",
    "admin.signInAs": "Sign in as…",
    "admin.pendingProofs": "Proofs to review",
    "admin.noProofs": "No pending proofs",
    "admin.proofConfirmed": "Subscription activated 🎉",
    "admin.rejectReason": "Rejection reason:",
    "admin.reminderSent": "WhatsApp reminder sent",
    "admin.dunning": "Dunning (past due)",
    "admin.daysLeft": "{days} days left",
    "admin.remind": "Remind",
    "admin.allSubs": "All subscriptions",
    "admin.proofPending": "proof pending",
    "admin.expected": "expected",
    "admin.revenueByMonth": "Revenue by month (confirmed payments)",
    "admin.allBars": "All bars",
    "admin.allDists": "All distributors",
    "admin.plan": "Plan",
    "admin.publish": "Publish",
    "admin.auditSearch": "Search (action, admin, target…)",
    "admin.tab.plans": "Plans & entitlements",
    "admin.tab.methods": "Payment methods",
    "admin.tab.templates": "WhatsApp templates",
    "admin.tab.flags": "Feature flags",
    "admin.plansWarning": "Changes apply immediately to every bar on the plan.",
    "admin.planSaved": "Plan saved — applied immediately",
    "clients.filter.all": "All",
    "clients.filter.checked_in": "Checked in",
    "clients.filter.open_debts": "Open debts",
    "clients.filter.credit_signed": "Credit signed",
    "clients.filter.no_credit": "No credit",
    "clients.sort.recent": "Recent activity",
    "clients.sort.name": "Name A–Z",
    "clients.sort.debt": "Highest debt",
    "clients.noMatch": "No client matches — check the number or register them at the counter above.",
    "clients.debtShort": "Debt",
    "common.prev": "Previous",
    "common.next": "Next",
    "clients.verified": "Verified",
    "orders.title": "Orders",
    "orders.live": "Live",
    "orders.history": "History",
    "orders.music": "Music",
    "orders.markServed": "Mark served",
    "orders.done": "Done",
    "orders.served": "Served",
    "orders.request": "Request",
    "orders.empty": "No pending orders — all good.",
    "orders.songEmpty": "No songs requested.",
    "orders.played": "Played",
    "orders.dismiss": "Dismiss",
    "bring.now": "Now",
    "bring.min10": "~10 min",
    "bring.min20": "~20 min",
    "bring.with_food": "With the food",
    "req.ice": "Ice",
    "req.waiter": "Waiter",
    "req.serviettes": "Napkins",
    "req.chairs": "Chairs",
    "req.piment": "Chili",
    "notify.markAll": "Mark all read",
    "notify.mute": "Mute sounds",
    "notify.unmute": "Unmute sounds",
    "consumer.welcome": "Welcome to",
    "consumer.table": "Table",
    "consumer.continueAs": "Continue as {name}? (…{last2})",
    "consumer.confirmPhone": "Confirm your full phone number",
    "consumer.resume": "Resume my session",
    "consumer.newSession": "New session",
    "consumer.checkinTitle": "Take a seat",
    "consumer.checkinDesc": "Your phone number opens your table.",
    "consumer.nameLabel": "Your name",
    "consumer.start": "Let's go",
    "consumer.otpTitle": "Verification code",
    "consumer.otpDesc": "Enter the code sent by SMS to {phone}.",
    "consumer.otpDev": "DEMO MODE — code: {code}",
    "consumer.verify": "Verify",
    "consumer.menuTitle": "The menu",
    "consumer.finished": "finished",
    "consumer.myOrders": "My orders",
    "consumer.orderBtn": "Order · {total}",
    "consumer.orderSent": "Order sent!",
    "consumer.orderServed": "Your order is served 🎉",
    "consumer.requests": "Need anything?",
    "consumer.requestSent": "Request sent",
    "consumer.song": "A song?",
    "consumer.songPlaceholder": "Title or artist…",
    "consumer.songSent": "Song request sent",
    "consumer.bringWhen": "When?",
    "consumer.payLater": "You pay at the end — relax.",
    "consumer.status.new": "Being prepared",
    "consumer.status.served": "Served",
    "consumer.status.cancelled": "Cancelled",
    "pay.kind.cash": "Cash",
    "billing.ref": "ref",
    "common.invalidJson": "Invalid JSON",
    "consumer.smsUnavailable": "SMS verification unavailable",
    "admin.adopt.table_qr": "🪑 QR tables",
    "admin.adopt.credit": "💳 Credit",
    "admin.adopt.pairing": "🚚 Pairing",
    "admin.adopt.home_delivery": "🛵 Delivery",
    "admin.perMonth": "/month",
    "admin.perYear": "/year",
    "admin.isPublic": "public",
    "admin.tplHint": "These WhatsApp messages are sent in the recipient's language — fill in both versions.",
    "supply.status.changes_proposed": "Changes proposed",
    "supply.timeline": "Timeline & discussion",
    "supply.desiredDate": "Desired date",
    "supply.diffTitle": "Proposed changes",
    "supply.newLine": "New line",
    "supply.removedLine": "Removed",
    "supply.unavailable": "Unavailable",
    "supply.proposeReplacement": "Propose a replacement",
    "supply.proposeChanges": "Propose changes",
    "supply.editOrder": "Edit the order",
    "supply.proposeNote": "Note (e.g. out of stock…)",
    "supply.proposeSave": "Send proposal",
    "supply.proposeSent": "Proposal sent",
    "supply.acceptProposal": "Accept proposal",
    "supply.declineEdit": "Decline / edit",
    "supply.proposalAccepted": "Proposal accepted ✅",
    "supply.frozen": "Awaiting the other side's reply…",
    "supply.addLine": "Add a line",
    "supply.commentPh": "Write a comment…",
    "supply.ev.comment": "Comment",
    "supply.ev.edited": "Order edited",
    "supply.ev.proposed": "Changes proposed",
    "supply.ev.proposal_accepted": "Proposal accepted",
    "supply.ev.proposal_declined": "Proposal declined",
    "supply.ev.terms_proposed": "Terms change proposed",
    "supply.ev.terms_accepted": "Terms accepted",
    "supply.ev.terms_declined": "Terms declined",
    "supply.ev.driver_payment": "Payment collected by rider",
    "portal.step.dispatched": "Dispatched",
    "portal.step.picked_up": "Picked up",
    "portal.step.arrived": "Arrived",
    "portal.step.completed": "Delivered",
    "time.justNow": "just now",
    "time.minAgo": "{m} min ago",
    "time.hourAgo": "{h} h ago",
    "ntf.order.new.title": "New order — {table}",
    "ntf.order.new.body": "{client}: {summary} · {total}",
    "ntf.request.new.title": "Request — {table}",
    "ntf.request.new.body": "{client}: {request_type}",
    "ntf.song.new.title": "Song request",
    "ntf.song.new.body": "{client}: {text}",
    "ntf.checkin.new.title": "Arrival — {table}",
    "ntf.checkin.new.body": "{client} just sat down",
    "ntf.payment.proof.title": "Payment proof received",
    "ntf.payment.proof.body": "{amount} via {method_kind} — to review",
    "ntf.payment.proof.mismatch": " ⚠️ OCR amount differs",
    "ntf.supply.placed.title": "New order — {bar_name}",
    "ntf.supply.placed.body": "{total}",
    "ntf.supply.placed.overLimit": " ⚠️ credit limit exceeded — approval required",
    "ntf.supply.received.title": "Order received",
    "ntf.supply.received.body": "{total} — the bar received the delivery",
    "ntf.supply.status.title": "Order {status} — {dist_name}",
    "ntf.supply.status.body": "{total}",
    "ntf.invoice.new.title": "New invoice — {dist_name}",
    "ntf.invoice.new.body": "{number} · {amount}",
    "ntf.hd.new.title": "Home delivery — {client}",
    "ntf.hd.new.body": "{total} · {address}",
    "ntf.partnership.request.title": "Partnership request — {dist_name}",
    "ntf.partnership.request.body": "Pairing code: {code} — accept it in Distributors",
    "ntf.supply.update.comment": "💬 New comment",
    "ntf.supply.update.proposed": "✏️ {actor_name} proposes changes",
    "ntf.supply.update.proposal_accepted": "✅ Proposal accepted",
    "ntf.supply.update.proposal_declined": "↩️ Proposal declined — order edited",
    "ntf.supply.update.edited": "✏️ Order edited by the bar",
    "ntf.supply.update.default": "Order updated",
    "ntf.supply.update.body": "{actor_name} — {text}",
    "ntf.credit.signed.title": "Credit agreement signed",
    "ntf.credit.signed.body": "{client} signed their tab agreement",
    "ntf.digest.daily.title": "Daily digest sent",
    "ntf.digest.daily.body": "✅ {confirmed} · ⏳ {pending} · ❌ {rejected}",
    "ntf.day.closed.title": "Day closed",
    "ntf.day.closed.body": "Sales {sales} · Profit {profit} — report sent to the owner",
    "ntf.day.closed.dist.title": "Day closed",
    "ntf.day.closed.dist.body": "Deliveries {deliveries} · Collected {collected} — report sent",
    "ntf.billing.active.title": "{plan} subscription active 🎉",
    "ntf.billing.active.body": "Valid until {date}",
    "ntf.billing.rejected.title": "Subscription proof rejected",
    "ntf.billing.rejected.body": "{reason}",
    "ntf.billing.renewal.title": "Subscription renewal",
    "ntf.billing.renewal.body": "Your {plan} plan expires in {days}d — renew to keep your features",
    "money.perMonth": "/month",
    "money.perYear": "/year",
    "common.total": "Total",
    "consumer.tableNotFound": "Table not found",
    "credit.linkNotFound": "Link not found",
    "admin.level.info": "Info",
    "admin.level.warning": "Warning",
    "admin.annFrPh": "Message (FR)",
    "admin.annEnPh": "Message (EN)",
    "pin.digitsPh": "4–6 digits",
    "profile.hoursPh": "Mon–Sun · 10am – 2am",
    "inv.colBar": "Bar",
    "inv.age1": "1–15 d",
    "inv.age2": "16–30 d",
    "inv.age3": "30+ d",
    "sub.status.trial": "Trial",
    "sub.status.active": "Active",
    "sub.status.past_due": "Past due",
    "sub.status.read_only": "Read-only",
    "sub.status.pending_payment": "Proof pending",
    "billing.staff": "staff",
    "billing.tablesQr": "QR tables",
    "admin.d7": "7 d",
    "admin.d30": "30 d",
    "sync.synced": "Synced",
    "sync.syncing": "Syncing…",
    "sync.offlinePending": "Offline — {n} pending",
    "sync.pendingShort": "{n} to sync",
    "sync.savedOffline": "Saved offline — will sync when back online",
    "sync.needsConnection": "Needs connection — this page will be available when back online",
    "sync.provisional": "Provisional — waiting to sync",
    "sync.issuesTitle": "Sync",
    "sync.issuesDesc": "Conflicts and offline actions to review — the server stays the source of truth",
    "sync.noIssues": "No sync issues",
    "sync.resolve": "OK, seen",
    "sync.retry": "Retry",
    "sync.deadEvents": "{n} action(s) could not be synced",
    "sync.updateReady": "New version available",
    "sync.refresh": "Refresh",
    "sync.toVerify": "to verify",
    "sync.issue.stockNegative": "Stock of {item} went negative ({stock}) — count the fridge",
    "sync.issue.sessionAlreadyClosed": "{client}'s session was already closed",
    "sync.issue.closedWithPending": "{client}'s session closed with {count} unserved order(s)",
    "sync.issue.duplicateCash": "Duplicate cash payment ignored ({amount})",
    "sync.issue.alreadyServed": "Order already served — action ignored",
    "sync.issue.failedEvent": "Action \u201c{type}\u201d failed: {error}",
    "sheet.title": "Order — {client}",
    "sheet.submitOrder": "Send order",
    "sheet.orderSent": "Order recorded ✓",
    "sheet.requestSent": "Request sent ✓",
    "sheet.newOrderBtn": "+ Order",
    "clients.nameRequired": "Name required for a new client",
    "clients.phoneInvalid": "Invalid phone number",
    "wa.remind": "Tab reminder",
    "wa.message": "Message",
    "wa.contact": "Contact",
    "wa.contactDepot": "Contact depot",
    "wa.share": "Share on WhatsApp",
    "wa.sendReport": "📱 Send report to my WhatsApp",
    "wa.sendInvite": "Send on WhatsApp",
    "wa.help": "Help on WhatsApp 💬",
    "wa.orderOnWa": "Order on WhatsApp",
    "wa.sendLocation": "📍 Or send your location on WhatsApp",
    "wa.requestLocation": "Request location 📍",
    "wa.notifyCustomer": "Notify customer 📱",
    "wa.sendJobDriver": "Send job to driver 📱",
    "wa.driverTip": "Tip: ask the driver to share his live location in your WhatsApp chat to follow the delivery.",
    "wa.contactDriver": "Driver",
    "wa.contactCustomer": "Customer",
    "wa.remindInvoice": "Remind",
    "wa.statement": "Balance reminder",
    "wa.renewalRemind": "Remind on WhatsApp",
    "wa.marketingOptIn": "OK to receive {bar}'s promos on WhatsApp",
    "wa.kitTitle": "WhatsApp Kit 💬",
    "wa.kitDesc": "Everything to sell more with WhatsApp — free, no setup needed",
    "wa.statusGen": "Images for your WhatsApp Status",
    "wa.statusStory": "Story 1080×1920",
    "wa.statusSquare": "Square 1080×1080",
    "wa.designOrder": "Order from home 🍻",
    "wa.designTable": "Scan, order at your table ✨",
    "wa.customLine": "Custom line (e.g. Big match tonight — giant screen!)",
    "wa.download": "Download",
    "wa.shareMyBar": "Share my storefront",
    "wa.copyLink": "Copy link",
    "wa.copied": "Link copied ✓",
    "wa.downloadQr": "Download QR (PNG)",
    "wa.channelSection": "WhatsApp number & channel",
    "wa.waNumber": "Bar's WhatsApp number",
    "wa.waNumberDist": "WhatsApp number",
    "wa.channelUrl": "Your WhatsApp Channel link",
    "wa.waOrderToggle": "\u201cOrder on WhatsApp\u201d button on the storefront",
    "wa.howtoTitle": "Pro WhatsApp in 4 steps",
    "wa.howto1": "1. Create a WhatsApp Business profile with the bar's name",
    "wa.howto2": "2. Fill in your opening hours and address",
    "wa.howto3": "3. Create a WhatsApp Channel and paste the link here",
    "wa.howto4": "4. Post your Status image every weekend",
    "wa.followBarpadi": "Follow BarPadi",
    "wa.followChannel": "Official BarPadi Channel 📢",
    "wa.supportChat": "BarPadi support 💬",
    "wa.shareCatalog": "Share my price list",
    "wa.invitePartner": "Invite a partner bar",
    "wa.followBar": "Follow {bar} on WhatsApp 📢",
    "wa.supportNumber": "Support WhatsApp number",
    "wa.barpadiChannel": "BarPadi Channel link",
    "settings.whatsappKit": "WhatsApp Kit 💬",
    "settings.whatsapp": "WhatsApp 💬",
    "wa.helpOpenerText": "Hello BarPadi 👋 I need some help.",
    "wa.seePairing": "(see Settings → Pairing)",
  },
};

const I18nContext = createContext(null);

// Backend error details are English strings; they act as keys, translated here at display time.
const apiErrorsFr = {
  "A cancellation reason is required": "Un motif d'annulation est requis",
  "Something went wrong. Please try again.": "Une erreur est survenue. Veuillez réessayer.",
  "A payment already exists for this order": "Un paiement existe déjà pour cette commande",
  "Payment required before serving": "Encaissez d'abord 💰 — paiement requis avant de servir",
  "Only the owner can offer gifts": "Seul le patron peut offrir des cadeaux",
  "Order is already a gift": "Cette commande est déjà offerte",
  "Slot not available": "Créneau non disponible",
  "Table already reserved for this slot": "Table déjà réservée pour ce créneau",
  "No table available for this slot": "Aucune table disponible pour ce créneau",
  "Reservations not enabled for this bar": "Réservations non activées pour ce bar",
  "Reservation not found": "Réservation introuvable",
  "Reservation can no longer be cancelled": "Cette réservation ne peut plus être annulée",
  "Invalid code": "Code invalide",
  "A payment for this order is already submitted or confirmed": "Un paiement pour cette commande est déjà envoyé ou confirmé",
  "A payment proof is already pending review": "Une preuve de paiement est déjà en cours de vérification",
  "A proof is already pending for this invoice": "Une preuve est déjà en attente pour cette facture",
  "Account disabled": "Compte désactivé",
  "Account not found": "Compte introuvable",
  "Agreement already signed": "Accord déjà signé",
  "Already signed": "Déjà signé",
  "An account with this phone already exists": "Un compte existe déjà avec ce numéro",
  "Bar item not found": "Article du bar introuvable",
  "Bar not found": "Bar introuvable",
  "Catalog item not available": "Article du catalogue indisponible",
  "Catalog item not found": "Article du catalogue introuvable",
  "Changes can only be proposed on a placed order": "Les modifications ne sont possibles que sur une commande passée",
  "Client not found": "Client introuvable",
  "Comments are closed on this order": "Les commentaires sont fermés sur cette commande",
  "Confirmation name does not match": "Le nom de confirmation ne correspond pas",
  "Day already closed": "Journée déjà clôturée",
  "Driver name and phone required": "Nom et téléphone du chauffeur requis",
  "Each line needs a bar item, a new item, or skip": "Chaque ligne doit avoir un article, un nouvel article, ou être ignorée",
  "Each line needs a catalog item or a name": "Chaque ligne doit avoir un article du catalogue ou un nom",
  "External link requires a URL": "Le lien externe nécessite une URL",
  "File not found": "Fichier introuvable",
  "File too large (max ~2 MB)": "Fichier trop volumineux (max ~2 Mo)",
  "Home delivery is not enabled for this bar": "La livraison à domicile n'est pas activée pour ce bar",
  "Insufficient permissions": "Permissions insuffisantes",
  "Insufficient permissions for this workspace": "Permissions insuffisantes pour cet espace",
  "Invalid code": "Code invalide",
  "Invalid phone number": "Numéro de téléphone invalide",
  "Invalid phone or password": "Téléphone ou mot de passe invalide",
  "Invalid plan": "Plan invalide",
  "Invalid status": "Statut invalide",
  "Invalid token": "Session invalide",
  "Invite code expired": "Code d'invitation expiré",
  "Invite code has expired": "Code d'invitation expiré",
  "Invite code not found": "Code d'invitation introuvable",
  "Invite code not found or already used": "Code d'invitation introuvable ou déjà utilisé",
  "Invoice already paid": "Facture déjà payée",
  "Invoice not found": "Facture introuvable",
  "Item not available": "Article indisponible",
  "Item not found": "Article introuvable",
  "Member not found": "Membre introuvable",
  "No active partnership with this distributor": "Aucun partenariat actif avec ce distributeur",
  "No credit profile for this client": "Pas de profil crédit pour ce client",
  "No membership in this workspace": "Aucune adhésion dans cet espace",
  "No open debt": "Aucune dette ouverte",
  "No open debts matched": "Aucune dette ouverte correspondante",
  "No open session on this table": "Aucune session ouverte sur cette table",
  "No pending payment": "Aucun paiement en attente",
  "No proposal to accept": "Aucune proposition à accepter",
  "No proposal to decline": "Aucune proposition à décliner",
  "No signed agreement": "Aucun accord signé",
  "Not a member": "Pas membre",
  "Not authenticated": "Non authentifié",
  "Receipt file not found": "Fichier du reçu introuvable",
  "Rider name and phone required": "Nom et téléphone du livreur requis",
  "A rider with this phone already exists": "Un livreur avec ce numéro existe déjà",
  "This rider has deliveries — deactivate instead": "Ce livreur a des livraisons — désactivez-le plutôt",
  "SMS provider error": "Erreur du fournisseur SMS",
  "Sell price cannot be below cost price": "Le prix de vente ne peut pas être inférieur au coût",
  "Sell price must be ≥ cost": "Le prix de vente doit être ≥ au coût",
  "Session has unserved orders": "La session a des commandes non servies",
  "Session is closed": "La session est clôturée",
  "Session not found": "Session introuvable",
  "Signature must match the full legal name": "La signature doit correspondre au nom complet",
  "Signing link not found": "Lien de signature introuvable",
  "Subscription proof not found": "Preuve d'abonnement introuvable",
  "Table not found": "Table introuvable",
  "Table number already exists": "Ce numéro de table existe déjà",
  "This invite was issued for a different phone number": "Cette invitation a été émise pour un autre numéro",
  "This person is already a team member": "Cette personne est déjà membre de l'équipe",
  "Token expired": "Session expirée",
  "Too many attempts. Try again in 15 minutes.": "Trop de tentatives. Réessayez dans 15 minutes.",
  "Too many requests. Please slow down.": "Trop de requêtes. Ralentissez un peu.",
  "Unknown request type": "Type de demande inconnu",
  "Write-off quantity exceeds stock": "La quantité de perte dépasse le stock",
  "Wrong PIN": "PIN incorrect",
  "Wrong password": "Mot de passe incorrect",
  "You are already a member of this team": "Vous êtes déjà membre de cette équipe",
  "You cannot deactivate yourself": "Vous ne pouvez pas vous désactiver vous-même",
};

export function translateApiError(msg) {
  if (typeof msg !== "string") return msg;
  const out = currentLang === "fr" ? apiErrorsFr[msg] || msg : msg;
  return pseudo ? `\u27e6${out}\u27e7` : out;
}

let currentLang = localStorage.getItem("bp_lang") || "fr";
let pseudo = new URLSearchParams(window.location.search).get("locale") === "test";

export function getLocale() {
  return currentLang === "fr" ? "fr-FR" : "en-GB";
}

function translate(lang, key, vars) {
  let s = dictionaries[lang]?.[key] ?? dictionaries.fr[key] ?? key;
  if (vars) Object.entries(vars).forEach(([k, v]) => (s = s.replace(`{${k}}`, v)));
  return pseudo ? `\u27e6${s}\u27e7` : s;
}

export function money(amount, cycle) {
  const base = `${Number(amount || 0).toLocaleString("fr-FR").replace(/\u202f|\u00a0/g, " ")} F`; // i18n-ok: money stays "38 700 F" in both languages
  if (!cycle) return base;
  const suffix = translate(currentLang, cycle === "annual" ? "money.perYear" : "money.perMonth");
  return `${base}${suffix}`;
}

export function timeAgo(iso) {
  const mins = Math.floor((Date.now() - new Date(iso).getTime()) / 60000);
  if (mins < 1) return translate(currentLang, "time.justNow");
  if (mins < 60) return translate(currentLang, "time.minAgo", { m: mins });
  if (mins < 1440) return translate(currentLang, "time.hourAgo", { h: Math.floor(mins / 60) });
  return new Date(iso).toLocaleDateString(getLocale());
}

const MONEY_PARAMS = new Set(["total", "amount", "sales", "profit", "collected", "cost"]);

export function renderNotif(n, t, formatMoney) {
  if (!n.params || Object.keys(n.params).length === 0) {
    if (n.title || n.body) return { title: n.title || "", body: n.body || "" };
  }
  const raw = n.params || {};
  const p = {};
  for (const [k, v] of Object.entries(raw)) {
    if (k === "method_kind") p[k] = t(`pay.kind.${v}`);
    else if (k === "status") p[k] = t(`supply.status.${v}`);
    else if (k === "request_type") p[k] = t(`req.${v}`);
    else if (k === "action") p[k] = t(`portal.action.${v}`);
    else if (k === "table") p[k] = !v || /^comptoir$/i.test(v) ? t("clients.counter") : v;
    else if (MONEY_PARAMS.has(k) && typeof v === "number") p[k] = formatMoney(v);
    else p[k] = v;
  }
  if (n.type === "supply.update") {
    const kind = ["comment", "proposed", "proposal_accepted", "proposal_declined", "edited"].includes(raw.kind)
      ? raw.kind : "default";
    return { title: t(`ntf.supply.update.${kind}`, p), body: t("ntf.supply.update.body", p) };
  }
  let title = t(`ntf.${n.type}.title`, p);
  let body = t(`ntf.${n.type}.body`, p);
  if (n.type === "payment.proof" && raw.mismatch) body += t("ntf.payment.proof.mismatch");
  if (n.type === "supply.placed" && raw.over_limit) body += t("ntf.supply.placed.overLimit");
  return { title, body };
}

export function I18nProvider({ children }) {
  const [lang, setLang] = useState(currentLang);

  const changeLang = useCallback((l) => {
    localStorage.setItem("bp_lang", l);
    currentLang = l;
    setLang(l);
  }, []);

  React.useEffect(() => {
    const h = (e) => {
      const l = e.detail;
      if ((l === "fr" || l === "en") && l !== currentLang) changeLang(l);
    };
    window.addEventListener("bp:lang", h);
    return () => window.removeEventListener("bp:lang", h);
  }, [changeLang]);

  const t = useCallback((key, vars) => translate(lang, key, vars), [lang]);

  const locale = lang === "fr" ? "fr-FR" : "en-GB";

  return <I18nContext.Provider value={{ lang, locale, setLang: changeLang, t }}>{children}</I18nContext.Provider>;
}

export function useI18n() {
  return useContext(I18nContext);
}
